export default {
  default: "th",
  /////////////////// landig page ///////////////////
  landingpagetoolbar: {
    home: "หน้าแรก",
    top_up: "เติมเงิน",
    manual: "คู่มือการใช้งาน",
    report: "แจ้งปัญหา",
    shareholder: "การประชุมผู้ถือหุ้น",
    contact: "ติดต่อเรา",
    login: {
      title: "เข้าสู่ระบบต่างๆ",
      portal: "เข้าสู่ระบบ Portal",
      package: "เข้าสู่ระบบ Package",
      eFactoring: "บริการ eFactoring",
      etax: "เข้าสู่ระบบ ETAX-SP",
      ePod: "เข้าสู่ระบบ E-Pod" // เข้าสู่ระบบ Transport
    },
    signup: {
      title: "ลงทะเบียน",
      oneplatform: "ลงทะเบียน Oneplatform",
      serviceetax: "ลงทะเบียน Service e-Tax"
    },
    etax_invoice: {
      full: "ใบกำกับภาษีแบบเต็ม",
      abb: "ใบกำกับภาษีแบบย่อ",
      dashbord: "ข้อมูลการใช้งาน",
      report: "รายงาน",
      report_setting: "ตั้งค่ารายงาน",
      search_documents: "คัดค้นเอกสาร",
      instead: "เอกสารออกแทน",
      log: "Process log",
      email: "Email relay Report"
    },
    logout: "ออกจากระบบ"
  },
  header: {
    title: "อันดับ 1",
    subTitle: "ผู้ให้บริการออกใบกำกับภาษีอิเล็กทรอนิกส์",
    subTitle1: "ที่ผ่านการรับรองตามมาตรฐานจากกรมสรรพากร",
    ref: "(ข้อมูล ณ วันที่ 1 กันยายน 2565)"
  },
  footer: {
    provided: "ให้บริการโดย",
    name_company_inet: "บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)",
    address1_inet:
      "1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12,IT ถ.เพชรบุรีตัดใหม่",
    address2_inet: "แขวง บางกะปิ เขต ห้วยขวาง กรุงเทพมหานคร 10310",
    dealer: "ตัวแทนจำหน่าย",
    name_company_one: "บริษัท วัน อิเล็กทรอนิกส์ บิลลิ่ง จำกัด (มหาชน)",
    address1_one: "1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 16 ถ.เพชรบุรีตัดใหม่",
    address2_one: "แขวง บางกะปิ เขต ห้วยขวาง กรุงเทพมหานคร 10310",
    press3: "กด 3"
  },
  landingpage_som: {
    title: "แจ้งปัญหาการใช้งาน e-Tax",
    email: "อีเมล",
    proble_topic: "หัวข้อปัญหา",
    detail: "รายละเอียดของปัญหา",
    btn_confirm: "ยืนยัน",
    btn_close: "ปิด",
    emailLabel: "อีเมล์แอดเดรส",
    emailCheck: "กรุณากรอกอีเมล์แอดเดรส",
    topicCheck: "กรุณากรอกหัวข้อปัญหา",
    formatEmail: "รูปแบบอีเมล์ไม่ถูกต้อง",
    alertSuccess: "ดำเนินการแจ้งปัญหาเรียบร้อย",
    ref: "เลขอ้างอิง: ",
    alertFail:
      "ไม่สามารถเปิด Ticket แจ้งปัญหาได้ เนื่องจากอีเมล์นี้อาจยังไม่ได้ลงทะเบียนที่ระบบ SOM",
    alertCatch: "ไม่สามารถแจ้งปัญหาได้ในขณะนี้ กรุณาลองใหม่ภายหลัง"
  },
  landingpage_attension: {
    title: "ติดต่อขอรับข้อมูล e-Tax",
    name: "ชื่อ-นามสกุล",
    tel: "เบอร์โทรติดต่อกลับ",
    email: "อีเมลแอดเดรส",
    company: "บริษัท",
    detail: "รายละเอียดที่ต้องการสอบถาม",
    btn_save: "บันทึก",
    btn_del: "ลบ",
    save_success: "บันทึกข้อมูลเรียบร้อย",
    detail_save_success:
      "ระบบได้รับข้อมูลของคุณแล้ว ขอบคุณที่ให้ความสนใจ e-Tax",
    reEnterData: "กรอกข้อมูลอีกครั้ง",
    backHome: "กลับไปที่หน้าเว็บไซต์",
    label_software: "กรุณากรอก Software ที่ใช้งานอยู่ปัจจุบัน",
    label_software_select: "กรุณาเลือก Software ที่ใช้งานอยู่ปัจจุบัน",
    softwareItems: [
      {
        text: "Express",
        value: "Express"
      },
      {
        text: "Peak Account",
        value: "PeakAccount"
      },
      {
        text: "BigWork",
        value: "BigWork"
      },
      {
        text: "Double M",
        value: "DoubleM"
      },
      {
        text: "Ada-Soft",
        value: "AdaSoft"
      },
      {
        text: "CD Organizer",
        value: "CDOrganizer"
      },
      {
        text: "Prosoft",
        value: "Prosoft"
      },
      {
        text: "อื่นๆ",
        value: "etc"
      }
    ],
    interestedPromotion: "สนใจ Promotion e-Tax Invoice",
    interestedPromotionDesc: "รายละเอียดโปรโมชั่น",
    interestedPromotionDescData: [
      {
        text: "ค่าบริการฟรี 6 เดือน",
        value: "สนใจโปรโมชั่นค่าบริการฟรี 6 เดือน"
      },
      {
        text: "ส่วนลด 50% 6 เดือน",
        value: "สนใจโปรโมชั่นส่วนลด 50% 6 เดือน"
      },
      {
        text: "ส่วนลด 25% 6 เดือน",
        value: "สนใจโปรโมชั่นส่วนลด 25% 6 เดือน"
      }
    ]
  },
  landingpage_ads: {
    detail:
      "ระบบหน้า Web Portal นี้เป็นการบริการ Customize ลูกค้าเฉพาะราย และ อยู่ระหว่างทดสอบระบบ ไม่อยู่ในเงื่อนไข, ขอบเขตการให้บริการ และการรับประกันการใช้งานของบริการ INET e-Tax Service Provider",
    detail1: "กดปุ่ม ยินยอมทดสอบ เพื่อยอมรับเงือนไข",
    detail2: "หรือ กดไม่ยินยอมทดสอบ หากท่านไม่ยอมรับเงื่อนไขนี้ ",
    btnAccept: "ยินยอมทดสอบ",
    batNot: "หรือ กดไม่ยินยอมทดสอบ หากท่านไม่ยอมรับเงื่อนไขนี้"
  },
  landingpage_shareholder: {
    title: "การประชุมผู้ถือหุ้น",
    subtitle: "เอกสารประจำปี 2564",
    document: "เอกสารผู้ถือหุ้น"
  },
  landingpage_sendinvoice: {
    title: "อีเมล (สำหรับส่ง Invoice)",
    btn_save: "บันทึกข้อมูล",
    rules: {
      rules_email: "กรุณากรอกอีเมล",
      rules_emailFix: "รูปแบบอีเมล์ไม่ถูกต้อง"
    }
  },
  /////////////////// webportal ///////////////////
  portaltoolbar: {
    home: "ข้อมูลส่วนตัว",
    service: "บริการ",
    otp: {
      login: "การเข้าระบบด้วย OTP",
      select: "กรุณาเลือกช่องทางสำหรับ OTP",
      note:
        "หมายเหตุ : การเปิดใช้งาน OTP จะมีผลบังคับ ใช้กับทุก Userที่ใช้เลข Tax ID เดียวกัน",
      btnCancle: "ยกเลิก",
      btnBtn: "ยืนยัน",
      on: "ใช้งาน OTP สำเร็จ",
      open: "เปิด",
      off: "ปิด"
    },
    login: {
      title: "เข้าสู่ระบบต่างๆ",
      package: "เข้าสู่ระบบ Package",
      etax: "เข้าสู่ระบบ ETAX-SP"
    },
    etax_invoice: {
      full: "ใบกำกับภาษีแบบเต็ม",
      abb: "ใบกำกับภาษีแบบย่อ",
      dashbord: "ข้อมูลการใช้งาน",
      report: "รายงาน",
      ocr: "OCR",
      report_setting: "ตั้งค่ารายงาน",
      search_documents: "คัดค้นเอกสาร",
      search_documents_link: "คลิกเพื่อไปยัง หน้าคัดค้นเอกสาร",
      instead: "เอกสารออกแทน",
      log: "Process log",
      email: "Email relay Report",
      listemail: "ข้อมูล Email ลูกค้า",
      logsendinvoicebyemail: "Logs ส่งเอกสารผ่านอีเมล",
      title_revenue: "การนำส่งสรรพากร",
      revenue: "นำส่งกรมตามช่วงเวลา",
      revenue_status: "ตรวจสอบสถานะ",
      delete_transaction: "ลบเอกสารออกจากระบบ",
      sentRevenuebyone: "นำส่งกรมตามเอกสาร"
    },
    bill: {
      title: "สร้างบิล",
      create_etax: "สร้าง E-tax",
      list_create_etax: "รายการสร้าง E-tax",
      setting_number: "ตั้งค่าเลขที่เอกสาร",
      createCancleInstead: "ออกใบลดหนี้",
      editTaxInvoice: "ออกแทนเอกสาร"
    },
    admin: {
      title: 'Logs ผู้ดูแลระบบ',
    },
    logsusage: "Logs การเข้าใช้งานระบบ",
    logsprintdocument: 'Logs พิมพ์เอกสาร',
    top_up: "เติมเงิน",
    manual: "คู่มือการใช้งาน",
    report: "แจ้งปัญหา",
    contact: "ติดต่อเรา",
    logout: "ออกจากระบบ",
    setting: "การตั้งค่า",
    group_user: "ตั้งค่าเข้าถึงข้อมูล (สาขาผู้ขาย)",
    sftp_confirm: "ระบบรับรองเอกสาร",
    taxbox: "อนุมัติเอกสาร",
    customize: "บัญชีพิเศษ",
  },
  searchdocument: {
    title: "คัดค้นเอกสาร",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      button_send_mail: "ส่งเมลที่เลือก",
      button_resend: "ส่งอีเมล",
      list_resend: [
        { text: "ส่งแยกตามจำนวนเอกสาร", value: "email_split" },
        { text: "ส่งทุกเอกสารในอีเมล 1 ฉบับ", value: "email_group" }
      ],
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      id: "เลขที่",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_fromemail: "วันที่ส่งอีเมล",
      condition_toemail: "ถึง",
      condition_status_email: "สถานะอีเมล",
      waiting_for_delivery: "รอนำส่ง"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      seller_branch: "เลขที่สาขาผู้ขาย",
      doc_type: "ประเภทเอกสาร",
      doc_id: "เลขที่เอกสาร",
      Process_date: "วันที่ส่งเอกสาร",
      Document_date: "วันที่ลงเอกสาร",
      buyer: "ผู้ซื้อ",
      buyer_tax: "เลขประจำตัว",
      buyer_name: "ชื่อ",
      buyer_branch: "เลขที่สาขา",
      select_file: "เลือกขอไฟล์",
      resend_sms: "ส่ง SMS",
      resend_onechat: "ส่ง Onechat",
      resend_mail: "ส่งอีเมล",
      resend_file: "ส่งไฟล์อีกครั้ง",
      resend_mail_select: "เลือกจำนวน",
      resend_mail_resend: "ส่งอีกครั้ง",
      no_data: "ไม่มีข้อมูล"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      specify: "กรุณาระบุเงื่อนไข",
      notAlow: "กรุณาเพิ่มสิทธิ์สำหรับใช้งาน Group branch",
      titleGroupBranch: "คุณยังไม่มีสิทธิ์ใช้งานเมนูนี้",
      subtitleGroupBranch: "กรุณาติดต่อผู้ดูแลระบบของคุณ (Owner / Admin) เพื่อเพิ่มสิทธิ์ โดยสามารถส่งลิงก์นี้ให้ผู้ดูแล:",
      pathGroupBranch: "https://etax.one.th/portal/group-user",
      title: "เอกสารลงวันที่ หรือ วันที่ส่งเอกสาร อย่างใดอย่างหนึ่ง",
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      information_err: "ไม่พบข้อมูลที่ใช้สำหรับดาวน์โหลดไฟล์",
      user_no_found: "ไม่พบรหัสผู้ใช้งาน",
      session: "เซสชั่นหมดอายุ",
      due_logged: "เนื่องจากเข้าสู่ระบบค้างนานเกินไป",
      btn_cancle: "ยกเลิก",
      btn_logout: "ออกจากระบบ",
      select_documents: "กรุณาเลือกเอกสารที่ต้องการนำส่งอีเมล",
      check_pdf: "กรุณาตรวจสอบจำนวนไฟล์ PDF",
      print_pdf: "สามารถ Print PDF ได้ครั้งละไม่เกิน 100 ไฟล์",
      select_pdf: "กรุณาเลือกไฟล์ PDF",
      select_pdf_max:
        "กรุณาเลือกไฟล์ PDF อย่างน้อย 1 ไฟล์ สูงสุดไม่เกิน 100 ไฟล์",
      print_err:
        "ไม่สามารถ Print PDF ได้ในขณะนี้ (เนื่องจากไม่สามารถเปิดไฟล์ PDF ได้)"
    }
  },
  deletetransaction: {
    title: "ลบเอกสารออกจากระบบ Etax",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_download: "ดาวน์โหลดตัวอย่างไฟล์",
      button_download_aselect: "เลือกไฟล์ import",
      button_del: "สามารถลบได้",
      button_no_del: "ไม่สามารถลบได้",
      detail_no_del: "เนื่องจากไฟล์ดังกล่าวได้ถูกนำส่งไปยังสรรพากรแล้ว",
      order: "รายการ",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_fromemail: "วันที่ส่งอีเมล",
      condition_toemail: "ถึง",
      condition_status_email: "สถานะอีเมล",
      waiting_for_delivery: "รอนำส่ง",
      other: "อื่นๆ"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      seller_branch: "เลขที่สาขาผู้ขาย",
      doc_type: "ประเภทเอกสาร",
      doc_id: "เลขที่เอกสาร",
      Process_date: "วันที่ส่งเอกสาร",
      Document_date: "วันที่ลงเอกสาร",
      buyer: "ผู้ซื้อ",
      buyer_tax: "เลขประจำตัว",
      buyer_name: "ชื่อ",
      buyer_branch: "เลขที่สาขา",
      select_file: "เลือกขอไฟล์",
      resend_sms: "ส่ง SMS",
      resend_onechat: "ส่ง Onechat",
      resend_mail: "ส่งอีเมล",
      resend_file: "ส่งไฟล์อีกครั้ง",
      resend_mail_select: "เลือกจำนวน",
      resend_mail_resend: "ส่งอีกครั้ง",
      no_data: "ไม่มีข้อมูล",
      status_del: "สามารถลบได้",
      status_no_del: "ไม่สามารถลบได้",
      description: "เนื่องจากไฟล์ดังกล่าวได้ถูกนำส่งไปยังสรรพากรแล้ว",
      download: "กำลังดาวน์โหลด..."
    },
    dialog: {
      title_text1: "สาเหตุการขอลบเอกสาร",
      title_text2: "รายการเอกสารที่ต้องการลบ",
      title_text3: "*** OTP จะถูกส่งไปที่อีเมล",
      title_text4: "คุณได้ทำการสำรองข้อมูลแล้วหรือไม่?",
      title_text5: "การลบเอกสาร ยังคงถูกคำนวนค่าการบริการจัดทำใบกำกับภาษีอยู่",
      title_text6: "ยืนยันการดำเนินการหรือไม่",
      title_text7:
        "หมายเหตุ: การลบเอกสารจะไม่สามารถกู้คืนเอกสารได้ และ จะถือว่าเอกสารที่ลบถูกนับ 1 Transaction",
      title_text8: "ใบกำกับภาษีที่ลงลายมืออิเล็กทรอนิกส์ครบถ้วนสมบูรณ์แล้ว ไม่สามารถยกเลิกได้ หากต้องการลบเอกสารจากระบบ โปรดสำรองข้อมูลกรณีถูกตรวจสอบภายหลัง",
      title_input: "ซึ่งมีตำแหน่งเป็น Owner ของบริษัท และ OTP มีอายุการใช้งาน",
      subtitle_text1: "กำลังลบไฟล์",
      subtitle_text2: "อีกครั้งหรือไม่?",
      subtitle_input: "นาที",
      label_text1: "กรุณากรอกสาเหตุการขอลบเอกสาร",
      label_text2: "กรุณาเลือกไฟล์ excel",
      label_text3: "กรุณากรอก email",
      success: "ใช่",
      no_success: "ไม่,ดำเนินการต่อ",
      btn_confirm: "ยืนยัน",
      btn_cancle: "ยกเลิก",
      btn_request: "ขอ OTP ใหม่",
      confirmDelete: "ยืนยันการลบเอกสาร",
      numDelete: "คุณต้องการลบเอกสารจำนวน"
    },
    itemsList: [
      { tab: "รายการเอกสารที่พบในฐานข้อมูล" },
      { tab: "รายการเอกสารที่ไม่พบในฐานข้อมูล" }
    ],
    swal: {
      otp_err: "ไม่สามารถขอ OTP ได้",
      email_err: "ไม่พบข้อมูล email ใน oneid",
      server_err:
        "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบเซิฟเวอร์ได",
      btn_confirm: "ยืนยัน",
      btn_cancle: "ยกเลิก",
      success: "สำเร็จ",
      fail: "ล้มเหลว",
      document_deleted: "ลบเอกสารออกจากระบบเรียบร้อย",
      session_expired: "เซสชั่นหมดอายุ กรุณาเข้าสู่ระบบใหม่",
      delete_document: "ไม่สามารถลบเอกสารได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ"
    }
  },
  process_log: {
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_excel: "ขอไฟล์ EXCEL",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      button_send_mail: "ส่งเมลที่เลือก",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      other: "อื่นๆ",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      process: [
        { text: "ทั้งหมด(ผ่าน,ไม่ผ่าน)", value: "null" },
        { text: "ผ่าน", value: "Y" },
        { text: "ไม่ผ่าน", value: "Z" },
        { text: "เอกสารที่ถูกลบ", value: "D" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_fromemail: "วันที่ส่งอีเมล",
      condition_toemail: "ถึง",
      condition_status_email: "สถานะอีเมล",
      waiting_for_delivery: "รอนำส่ง",
      condition_seller_contact: "ชื่อผู้ติดต่อ"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      seller_branch: "เลขที่สาขาผู้ขาย",
      doc_type: "ประเภทเอกสาร",
      doc_id: "เลขที่เอกสาร",
      Process_date: "วันที่ส่งเอกสาร",
      Document_date: "วันที่ลงเอกสาร",
      buyer: "ผู้ซื้อ",
      buyer_tax: "เลขประจำตัว",
      buyer_name: "ชื่อ",
      buyer_branch: "เลขที่สาขา",
      select_file: "เลือกขอไฟล์",
      resend_sms: "ส่ง SMS",
      resend_onechat: "ส่ง Onechat",
      resend_mail: "ส่งอีเมล",
      resend_file: "ส่งไฟล์อีกครั้ง",
      resend_mail_select: "เลือกจำนวน",
      resend_mail_resend: "ส่งอีกครั้ง",
      no_data: "ไม่มีข้อมูล"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      specify: "กรุณาระบุเงื่อนไข",
      title: "เอกสารลงวันที่ หรือ วันที่ส่งเอกสาร อย่างใดอย่างหนึ่ง",
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      information_err: "ไม่พบข้อมูลที่ใช้สำหรับดาวน์โหลดไฟล์",
      user_no_found: "ไม่พบรหัสผู้ใช้งาน",
      session: "เซสชั่นหมดอายุ",
      due_logged: "เนื่องจากเข้าสู่ระบบค้างนานเกินไป",
      btn_cancle: "ยกเลิก",
      btn_logout: "ออกจากระบบ",
      select_documents: "กรุณาเลือกเอกสารที่ต้องการนำส่งอีเมล",
      check_pdf: "กรุณาตรวจสอบจำนวนไฟล์ PDF",
      print_pdf: "สามารถ Print PDF ได้ครั้งละไม่เกิน 100 ไฟล์",
      select_pdf: "กรุณาเลือกไฟล์ PDF",
      select_pdf_max:
        "กรุณาเลือกไฟล์ PDF อย่างน้อย 1 ไฟล์ สูงสุดไม่เกิน 100 ไฟล์"
    },
    loading_search: "กำลังค้นหา...",
    btn_loadexcel: "ขอไฟล์ EXCEL",
    chip_success: "สร้างเอกสารสำเร็จ",
    chip_fail: "สร้างเอกสารไม่สำเร็จ",
    chip_delete: "เอกสารถูกลบ",
    var_headers: [
      {
        text: "ลำดับ",
        align: "center",
        sortable: false,
        value: "no"
      },
      {
        text: "เอกสารลงวันที่",
        value: "document_date",
        sortable: false,
        align: "center"
      },
      {
        text: "เลขที่เอกสาร",
        value: "document_id",
        sortable: false,
        align: "center"
      },
      {
        text: "ประเภทเอกสาร",
        value: "document_type_code",
        sortable: false,
        align: "center"
      },
      {
        text: "Service code",
        value: "service_code",
        sortable: false,
        align: "center"
      },
      {
        text: "Usercode",
        value: "user_code",
        sortable: false,
        align: "center"
      },
      {
        text: "วันที่ส่งเอกสาร",
        value: "process_dtm",
        sortable: false,
        align: "center"
      },
      {
        text: "สถานะ",
        value: "process_finish_ind",
        sortable: false,
        align: "center"
      },
      {
        text: "Error_message",
        value: "er_message",
        sortable: false,
        align: "center"
      },
      {
        text: "ชื่อผู้ติดต่อ",
        value: "seller_contact_person_name",
        sortable: false,
        align: "center"
      },
      {
        text: "แผนกผู้ขาย",
        value: "seller_department",
        align: "center",
        sortable: false
      },
      {
        text: "Document remark11",
        value: "document_remark11",
        sortable: false
      },
      {
        text: "Source system",
        value: "source_system",
        sortable: false
      },
      {
        text: "วันที่ลบเอกสาร (username)",
        value: "delete_user",
        align: "center",
        sortable: false
      },
    ]
  },
  logsusage: {
    title: "Logs การเข้าใช้งานระบบ",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_excel: "ขอไฟล์ Excel",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      condition_fromdate: "วันที่",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_close_dialog: "ปิด",
      condition_locale: "TH"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      date: "วันที่",
      status: "สถานะ",
      no_data: "ไม่มีข้อมูล",
      status_success: "สำเร็จ",
      status_fail: "ไม่สำเร็จ"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์"
    }
  },
  logsprintdocument: {
    title: 'Logs พิมพ์เอกสาร',
    success: 'สำเร็จ',
    fail: 'ไม่สำเร็จ',
    loading_delete: "กำลังลบเอกสาร...",
    condition: {
      title: 'ระบุเงื่อนไขการค้นหา',
      button_search: 'ค้นหา',
      button_cler: 'เคลียร์ข้อมูล',
      button_excel: 'ขอไฟล์ Excel',
      button_download: 'ดาวน์โหลดเอกสาร',
      button_download_all: 'ดาวน์โหลดเอกสารทั้งหมด',
      button_download_aselect: 'ดาวน์โหลดเอกสารที่เลือก',
      condition_fromdate_print: 'วันที่พิมพ์เอกสาร',
      condition_todate_print: 'ถึง',
      condition_fromdate: 'วันที่ส่งเอกสาร',
      condition_todate: 'ถึง',
      condition_fromdatedoc: 'เอกสารลงวันที่',
      condition_todatedoc: 'ถึง',
      condition_processhint: 'กรุณาเลือกเอกสารลงวันที่',
      condition_close_dialog: 'ปิด',
      condition_locale: 'TH',
      condition_docid: 'เลขที่เอกสาร',
      condition_todocid: 'ถึง',
      condition_processid: 'Process id',
      detail_print_date: 'วันที่พิมพ์เอกสาร คือวันที่ระบุพิมพ์เอกสาร',
      detail_doc_date: 'เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร',
      seller_department: 'แผนกผู้ขาย',
      seller_contact: 'ชื่อผู้ติดต่อ',
      seller_branchid: 'เลขที่สาขา(ผู้ขาย)',
      doctype: 'ประเภทเอกสาร',
      buyer_taxid: 'เลขประจำตัวผู้เสียภาษีอากร',
      buyer_id: 'รหัสผู้ซื้อ',
      buyer_name: 'ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)',
      buyer_branchid: 'เลขที่สาขา(ผู้ซื้อ)',
      other: 'อื่นๆ',
      doctype_list_all: [
        { value: "", text: "ทุกประเภท" },
        { value: '380', text: "ใบแจ้งหนี้" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" }
      ],
    },
    dialog_download: {
      loading_download: "กำลังดาวน์โหลด...",
    },
    detail: {
      doc_found: 'จำนวนเอกสารที่ค้นพบ :',
      pdf: 'ไฟล์ PDF ที่เลือก :',
      xml: 'ไฟล์ XML ที่เลือก :'
    },
    table: {
      no: 'ลำดับ',
      date: 'วันที่',
      status: 'สถานะ',
      no_data: 'ไม่มีข้อมูล',
      document_id: 'เลขที่เอกสาร',
      date: 'วันที่',
      process_id: 'Process Id',
      seller_tax_id: 'เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)',
      seller_branch_id: 'เลขที่สาขาผู้ขาย',
      document_date: 'วันที่ลงเอกสาร',
      document_type: 'ประเภทเอกสาร',
      buyer_branch_id: 'เลขที่สาขา (ผู้ซื้อ)',
      buyer_name: 'ชื่อ',
      buyer_serial_no: 'เลขผู้เสียภาษี (ผู้ซื้อ)',
      source_system: 'Source system',
      status_ok: 'สำเร็จ',
      status_er: 'ไม่สำเร็จ',
      status_desc: 'รายละเอียด',
      print_date: 'วันที่พิมพ์เอกสาร'
    },
    dialog_email: {
      noemail_text1: 'ไม่พบอีเมลสำหรับส่งไฟล์',
      noemail_text2: 'ระบุอีเมลที่ต้องการส่งไฟล์',
      noemail_text3: 'ต้องการเพิ่มอีเมลหรือไม่?',
      noemail_input: 'อีเมลแอดเดรส',
      havemail_text1: 'คุณต้องการส่งไฟล์ไปยัง',
      havemail_text2: 'อีกครั้งหรือไม่?',
      havemail_input: 'อีเมลแอดเดรส',
      accesskey_text1: 'กรุณากรอก accesskey',
      accesskey_text2: 'หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที',
      loading: 'กำลังส่ง...',
      complete: 'สำเร็จ',
      btn_confirm: 'ยืนยันการส่ง',
      btn_edit: 'แก้ไขอีเมล',
      btn_add: 'เพิ่มอีเมล'
    },
    dialog_download: {
      accesskey_text1: 'กรุณากรอก accesskey',
      accesskey_text2: 'หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที',
      notify_text1: 'การดาวน์โหลดไฟล์ใช้เวลานาน ',
      notify_text2: 'ต้องการดาวน์โหลดหรือไม่?',
      btn_confirm: 'ยืนยัน',
      loading_download: 'กำลังดาวน์โหลด..'
    },
    swal: {
      server_err: 'ไม่สามารถเชื่อมต่อเซิฟเวอร์ได้',
      accesskey_err: 'AccessKey ไม่ถูกต้อง',
      download_err: 'ไม่สามารถโหลดไฟล์ได้',
      morefile_err: 'เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์',
      specify: 'กรุณาระบุเงื่อนไข',
      title: 'วันที่พิมพ์เอกสาร หรือเอกสารลงวันที่',
    }
  },
  report: {
    title: "รายงาน",
    condition: {
      title: "ระบุเงื่อนไข",
      button_search: "เรียกดูรายงาน",
      button_cler: "เคลียร์ข้อมูล",
      button_export_excel: "ขอไฟล์ Excel",
      button_export_classification: "แบบแยกประเภทเอกสาร",
      button_export_without: "แบบไม่แยกประเภทเอกสาร",
      button_export_vat: "รายงานรายละเอียดภาษีขาย",
      button_export_summary_vat: "รายงานสรุปภาษีขาย",
      tabReceiptSummary: "รายงานสรุปการรับ ส่งและจัดทำใบกำกับภาษี",
      company: "ชื่อบริษัท",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      seller_department: "แผนกผู้ขาย",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        // { value: '380', text: 'ใบแจ้งหนี้' },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" }
      ],
      doctype_list_nosend: [
        { value: "", text: "ทุกประเภท" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      doctype_list_all: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      process: [
        { value: "null", text: "ทั้งหมด" },
        { value: "Y", text: "ผ่าน" },
        { value: "Z", text: "ไม่ผ่าน" }
      ],
      condition_venderSpilt: [
        { value: "S", text: "แสดง" },
        { value: "N", text: "ไม่แสดง" }
      ],
      rdStatus: [
        { text: "ทั้งหมด", value: "null" },
        { text: "ยังไม่นำส่งสรรพากร", value: "N|A" },
        { text: "เตรียมจัดส่งให้สรรพากร", value: "B" },
        { text: "รอข้อมูลการตอบกลับจากสรรพากร", value: "W" },
        { text: "นำส่งสรรพากรสำเร็จ", value: "R" },
        { text: "นำส่งสรรพากรไม่สำเร็จ", value: "E" }
      ],
      filter_type_doc: [
        { text: "ทั้งหมด", value: "all" },
        { text: "นำส่งสรรพากร", value: "send" },
        { text: "ไม่นำส่งสรรพากร", value: "no_send" }
      ],
      items_tab: [
        { tab: "ข้อมูลเอกสาร" },
        { tab: "ข้อมูลยอดรวมแบ่งตามเอกสาร" }
      ],
      tab_vender: "ข้อมูลยอดรวมแบ่งตามลูกค้า",
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid_head: "เลขประจำตัวผู้เสียภาษี",
      condition_buyer_branchid_head: "เลขที่สาขา",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_status_send: "สถานะการนำส่ง",
      condition_template: "Template รายงาน",
      condition_select_template: "กรุณาเลือก Template รายงาน",
      condition_choose_document: "เลือกรูปแบบเอกสาร",
      condition_choose_customer: "เลือกแสดงยอดรวมแบ่งตามลูกค้า",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      other: "อื่นๆ",
      num_doc: "จำนวนเอกสาร",
      amount: "จำนวนเงิน",
      tax: "ที่ไม่เสียภาษี",
      product_value: "มูลค่าสินค้า",
      service: "/บริการ",
      tax_total_amount: "มูลค่าภาษี",
      grand_total_amount: "มูลค่าสุทธิ",
      wht_total_amount: "หักภาษี ณ ที่จ่าย",
      actual_payment_total_amount: "จำนวนเงินที่ได้รับชำระ",
      classified: "แบ่งตามประเภทเอกสาร(ไม่รวมยกเลิก)",
      including: "รวมเอกสาร(ไม่รวมยกเลิก)",
      release: "แบ่งตามประเภทเอกสาร(ยกเลิก/ออกแทน)",
      include_release: "รวมเอกสาร(ยกเลิก/ออกแทน)",
      all_documents: "รวมเอกสารทั้งหมด",
      customer_name: "ชื่อลูกค้า"
    },

    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      doc_type: "ประเภทเอกสาร",
      doc_id: "เลขที่เอกสาร",
      Process_date: "วันที่ส่งเอกสาร",
      Document_date: "เอกสารลงวันที่",
      buyer: "ผู้ซื้อ",
      buyer_id: "รหัสผู้ซื้อ",
      buyer_tax: "เลขประจำตัวผู้เสียภาษี",
      buyer_name: "ชื่อผู้ซื้อ",
      buyer_branch: "เลขที่สาขา",
      select_file: "เลือกขอไฟล์",
      resend_mail: "ส่งอีเมลอีกครั้ง",
      no_data: "ไม่มีข้อมูล",
      basis_amount_vat7: "มูลค่าสินค้าที่นำมาคิดภาษี 7%",
      tax_cal_amount_vat7: "มูลค่าภาษี 7%",
      basis_amount_vat0: "มูลค่าสินค้าที่นำมาคิดภาษี 0%",
      tax_cal_amount_vat0: "มูลค่าภาษี 0%",
      notax_total_amount: "จำนวนเงินที่ไม่เสียภาษีมูลค่าเพิ่ม",
      tax_basis_total_amount: "มูลค่าสินค้า/บริการ",
      tax_total_amount: "มูลค่าภาษี",
      grand_total_amount: "มูลค่าสุทธิ",
      wht_total_amount: "หักภาษี ณ ที่จ่าย",
      actual_payment_total_amount: "จำนวนเงินที่ได้รับชำระ",
      reason: "สาเหตุการยกเลิก",
      reference_num: "เลขที่เอกสารอ้างอิง",
      reference_date: "วันที่เอกสารอ้างอิง",
      voucher_no: "เลขที่ voucher",
      status_send: "สถานะการนำส่งเอกสาร",
      seller_department: "แผนกผู้ขาย",
      seller_branch_id: "สาขาผู้ขาย",
      other: "อื่นๆ",

      status_type_doc: "เอกสารประเภทนี้ไม่นำส่งสรรพากร",
      status_not_delivered: "ยังไม่นำส่งสรรพากร",
      status_prepare_deliver: "เตรียมจัดส่งให้สรรพากร",
      status_wait_data: "รอข้อมูลการตอบกลับจากสรรพากร",
      status_success: "นำส่งสรรพากรสำเร็จ",
      status_failed: "นำส่งสรรพากรไม่สำเร็จ",
      status_process: "กำลังนำส่ง",
      status_size: "ขนาดไฟล์ XML เกิน 3 MB",
      month: "เดือน",
      receivedItem: "รายการที่ได้รับ",
      createdFailed: "รายการที่สร้างไม่สำเร็จ",
      createdSuccess: "รายการที่สร้างสำเร็จ",
      createdNext: "รายการเอกสารลงวันที่ ที่ถูกสร้างเดือนถัดไป",
      createdPrevious: "รายการเอกสารลงวันที่ ที่ถูกสร้างเดือนก่อนหน้า",
      deliveredRevenue: "รายการที่นำส่งสรรพากร",
      branchId: "สำนักงานใหญ่"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      download_report_err: "ไม่สามารถโหลดข้อมูลรายงานได้",
      download_file_err: "ไม่สามารถดาวน์โหลดไฟล์รายงานได้"
    }
  },
  report_instead: {
    title: "เอกสารออกแทน",
    condition: {
      title: "ระบุเงื่อนไข",
      button_search: "เรียกดูรายงาน",
      button_cler: "เคลียร์ข้อมูล",
      button_export_excel: "ขอไฟล์ Excel",
      button_export_classification: "แบบแยกประเภทเอกสาร",
      button_export_without: "แบบไม่แยกประเภทเอกสาร",
      company: "ชื่อบริษัท",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      condition_status_doc: "สถานะเอกสาร",
      items_status_doc: [
        { value: "", text: "ทุกสถานะ" },
        { value: "PENDING", text: "เอกสารรอการตรวจสอบ" },
        { value: "REJECT", text: "เอกสารไม่ผ่านการตรวจสอบ" },
        { value: "SUCCESS", text: "เอกสารผ่านการตรวจสอบ" },
      ],
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        // { value: '380', text: 'ใบแจ้งหนี้' },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" }
      ],
      doctype_list_nosend: [
        { value: "", text: "ทุกประเภท" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      doctype_list_all: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      process: [
        { value: "null", text: "ทั้งหมด" },
        { value: "Y", text: "ผ่าน" },
        { value: "Z", text: "ไม่ผ่าน" }
      ],
      condition_venderSpilt: [
        { value: "S", text: "แสดง" },
        { value: "N", text: "ไม่แสดง" }
      ],
      rdStatus: [
        { text: "ทั้งหมด", value: "null" },
        { text: "ยังไม่นำส่งสรรพากร", value: "N|A" },
        { text: "เตรียมจัดส่งให้สรรพากร", value: "B" },
        { text: "รอข้อมูลการตอบกลับจากสรรพากร", value: "W" },
        { text: "นำส่งสรรพากรสำเร็จ", value: "R" },
        { text: "นำส่งสรรพากรไม่สำเร็จ", value: "E" }
      ],
      filter_type_doc: [
        { text: "ทั้งหมด", value: "all" },
        { text: "นำส่งสรรพากร", value: "send" },
        { text: "ไม่นำส่งสรรพากร", value: "no_send" }
      ],
      items_tab: [
        { tab: "ข้อมูลเอกสาร" },
        { tab: "ข้อมูลยอดรวมแบ่งตามเอกสาร" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_status_send: "สถานะการนำส่ง",
      condition_template: "Template รายงาน",
      condition_select_template: "กรุณาเลือก Template รายงาน",
      condition_choose_document: "เลือกรูปแบบเอกสาร",
      condition_choose_customer: "เลือกแสดงยอดรวมแบ่งตามลูกค้า",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      other: "อื่นๆ",
      num_doc: "จำนวนเอกสาร",
      amount: "จำนวนเงิน",
      tax: "ที่ไม่เสียภาษี",
      product_value: "มูลค่าสินค้า",
      service: "/บริการ",
      tax_total_amount: "มูลค่าภาษี",
      grand_total_amount: "มูลค่าสุทธิ",
      wht_total_amount: "หักภาษี ณ ที่จ่าย",
      actual_payment_total_amount: "จำนวนเงินที่ได้รับชำระ",
      classified: "แบ่งตามประเภทเอกสาร(ไม่รวมยกเลิก)",
      including: "รวมเอกสาร(ไม่รวมยกเลิก)",
      release: "แบ่งตามประเภทเอกสาร(ยกเลิก/ออกแทน)",
      include_release: "รวมเอกสาร(ยกเลิก/ออกแทน)",
      all_documents: "รวมเอกสารทั้งหมด",
      customer_name: "ชื่อลูกค้า"
    },

    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      doc_type: "ประเภทเอกสาร",
      doc_id: "เลขที่เอกสาร",
      Process_date: "วันที่ส่งเอกสาร",
      Document_date: "เอกสารลงวันที่",
      buyer: "ผู้ซื้อ",
      buyer_id: "รหัสผู้ซื้อ",
      buyer_tax: "เลขประจำตัวผู้เสียภาษี",
      buyer_name: "ชื่อผู้ซื้อ",
      buyer_branch: "เลขที่สาขา",
      select_file: "เลือกขอไฟล์",
      resend_mail: "ส่งอีเมลอีกครั้ง",
      no_data: "ไม่มีข้อมูล",
      documents_issued: "รายการเอกสารออกแทน",
      seller_branch_id: "สาขาที่",
      no_issued: "เลขที่เอกสารออกแทน",
      doc_date_issued: "เอกสารลงวันที่ออกแทน",
      doc_type_issued: "ประเภทเอกสารออกแทน",
      date_issued: "วันที่ส่งเอกสารออกแทน",
      seller_department: "แผนกผู้ขาย"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      download_report_err: "ไม่สามารถโหลดข้อมูลรายงานได้",
      download_file_err: "ไม่สามารถดาวน์โหลดไฟล์รายงานได้",
      specify: "กรุณาระบุเงื่อนไข",
      title: "เอกสารลงวันที่ หรือ วันที่ส่งเอกสาร อย่างใดอย่างหนึ่ง",
      catch_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ"
    }
  },
  revenue: {
    title: "สรรพากร",
    accesskey: "AccessKey",
    title1: "ตรวจสอบสถานะการนำส่งเอกสาร",
    conditionTitle: "ระบุเงื่อนไขการตรวจสอบ",
    btnCheck: "ตรวจสอบสถานะ",
    btnClear: "เคลียร์ข้อมูล",
    no: "ลำดับ",
    docdate: "เอกสารลงวันที่",
    date: "วันที่ส่งเอกสาร",
    rdDate: "วันที่ยืนส่งกรม",
    doctype: "ประเภทเอกสาร",
    sourceSystem: "Source system",
    conditionsRD: "เงื่อนไขการส่งกรม",
    docSend: "เอกสารที่นำส่ง",
    success: "ส่งสำเร็จ",
    fail: "ส่งไม่สำเร็จ",
    wait: "รอการตอบกลับจากกรมสรรพากร",
    process: "เตรียมการนำส่ง",
    status: "สถานะการนำส่งกรมสรรพากร",
    report: "ดูรายงาน",
    noData: "ไม่มีข้อมูล",
    statusN: "ยังไม่นำส่งสรรพากร",
    statusP: "เตรียมจัดส่งให้สรรพากร",
    statusY: "นำส่งสรรพากรสำเร็จ",
    statusS: "ขนาดไฟล์ XML เกิน 3 MB",
    statusZ: "นำส่งสรรพากรไม่สำเร็จ",
    statusB: "เตรียมจัดส่งให้สรรพากร",
    statusW: "รอข้อมูลการตอบกลับจากสรรพากร",
    statusC: "ใบรับรองอิเล็คทรอนิกส์หมดอายุ",
    reponseErr: "ไม่สามารถตรวจสอบสถานะได้",
    notDefine: "ไม่ได้ระบุ",
    SendRevenueData: "วันที่กดนำส่งสรรพากร",
    title2: "นำส่งเอกสารไปยังกรมสรรพากร (ตามช่วงเวลา)",
    note: "หมายเหตุ",
    btnSend: "นำส่งเอกสาร",
    detail: "รายละเอียดเอกสารที่ต้องการนำส่ง",
    btnConfirmSend: "ยืนยันการนำส่ง",
    swalSuccess: "ดำเนินการสำเร็จ",
    numberInvoiceSend: "คุณต้องการ นำส่งเอกสารจำนวน",
    numberInvoiceSendTail: "ใบ หรือไม่",
    btnCancle: "ยกเลิก",
    btnConfimr: "ยืนยัน",
    sentRevenue: "เอกสารในช่วงเวลาดังกล่าวได้มีการนำส่งไปยังสรพากรแล้ว",
    sentRevenueDone: "ดำเนินการส่ง invoice เรียบร้อย",
    sumTax: "มูลค่ารวมภาษี",
    invoiceNum: "จำนวนเอกสาร",
    invoiceNumUint: "ใบ",
    mistake: "ผิดพลาด",
    refer: "อ้างอิง ประกาศอธิบดีกรมสรรพากร (ฉบับที่ 15)",
    titleCondition:
      "เรื่อง กำหนดหลักเกณฑ์ วิธีการ และเงื่อนไขในการจัดทำ ส่งมอบและเก็บรักษา ใบกำกับภาษีอิเล็กทรอนิกส์ และใบรับอิเล็กทรอนิกส์",
    dataEtaxMonth:
      "  ข้อ 15 ให้ผู้ออกใบกำกับภาษีอิเล็กทรอนิกส์หรือผู้ออกใบรับอิเล็กทรอนิกส์มีหน้าที่ส่งข้อมูลที่เกี่ยวข้องกับใบกำกับภาษีอิเล็กทรอนิกส์",
    orEtaxMonth:
      "หรือใบรับอิเล็กทรอนิกส์ให้แก่กรมสรรพากร เป็นรายเดือน โดยผ่านระบบอิเล็กทรอนิกส์ของกรมสรรพากร",
    onNextMonth: "ภายในวันที่ 15 ของเดือนถัดไป",
    contactEtax:
      "ระบบจะใช้เวลาในการนำส่งไปยังกรมสรรพากรประมาณ 3-7 วัน (ขึ้นอยู่กับจำนวนเอกสารและช่วงเวลาในการนำส่ง) หากพบปัญหาในการนำส่ง กรุณาติดต่อกลับมาที่ support@etax.one.th",
    delete_transaction: "ลบเอกสารออกจากระบบ",
    sentRevenuebyone: "นำส่งเอกสารไปยังกรมสรรพากร (ตามเอกสาร)",
    condition_send: "ระบุเงื่อนไขการนำส่ง",
    revenue_send_list: "รายการนำส่งสรรพากร",
    btnSendRevenue: "นำส่งสรรพากร",
    btnConfirmSendRevenue: "ยืนยันการนำส่งสรรพากร",

    table: {
      no: "ลำดับ",
      documentId: "เลขที่เอกสาร",
      status: "สถานะการนำส่ง",
      errorMessage: "หมายเหตุ",
      doc_date: "เอกสารลงวันที่",
      buyer_name: "ชื่อผู้ซื้อ",
      tax_id: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      process_date: "วันที่ส่งเอกสาร",
      document_date: "เอกสารลงวันที่",
      seller_branch: "สาขาผู้ขาย",
      document_name: "ประเภทเอกสาร",
      buyer_branch: "สาขาผู้ซื้อ",
      statusResend: "พร้อมนำส่ง"
    },
    tab_one: "สถานะการนำส่งสรรพากรแบบช่วงเวลา",
    tab_two: "สถานะการนำส่งสรรพากรตามเอกสาร",
    table_status_total: "จำนวนเอกสารทั้งหมด",
    table_status_unsend: "เอกสารที่ยังไม่นำส่ง",
    table_status_prepare: "เตรียมการนำส่ง",
    table_status_work: "รอการตอบกลับจากกรมสรรพากร",
    table_status_success: "นำส่งสำเร็จ",
    table_status_fail: "นำส่งไม่สำเร็จ",
    table_status_3mb: "XML เกิน 3 MB"
  },
  profile: {
    setting: "ข้อมูลทั่วไป",
    setting_access: "ตั้งค่าสิทธิ์การใช้งาน",
    setting_group_branch: "กำหนดการเข้าถึงข้อมูล (สาขาผู้ขาย)",
    setting_user: "ข้อมูลทั่วไป (ส่วนผู้ใช้งาน)",
    setting_company: "ข้อมูลทั่วไป (ส่วนบริษัท)",
    setting_service: "ตั้งค่า Service SMS",
    status_active: "พร้อมใช้งาน",
    status_no_active: "ไม่พร้อมใช้งาน",
    title: "ข้อมูลส่วนตัว",
    name: "ชื่อผู้ใช้งาน",
    company: "ชื่อบริษัท",
    branch_id: "สาขา",
    address: "ที่อยู่",
    no: "เลขที่",
    floor: "ชั้น",
    building: "อาคาร",
    address_no: "เลขที่",
    address_road: "ถนน",
    address_sub_district: "ตำบล/แขวง",
    address_district: "อำเภอ/เขต",
    address_province: "จังหวัด",
    address_postal_code: "รหัสไปรษณีย์",

    address_room_no: "ห้องที่",
    address_moo_ban: "หมู่บ้าน",
    address_moo_no: "หมู่ที่",
    address_soi: "ซอย",
    address_yaek: "แยก",

    title_revenue: "การนำส่งสรรพากร",
    send_revenue: "ส่งสรรพากร",
    tax_id: "เลขประจำตัวผู้เสียภาษี",
    birthday: "วันเดือนปีเกิด",
    email: "อีเมล",
    modify: "แก้ไข",
    status: "สถานะ",
    type: "รูปแบบนำส่ง",
    details: "รายละเอียด",
    regular_delivery: "ส่งประจำ",
    btn_save: "บันทึก",
    btn_cancle: "ยกเลิก",
    set_time: "ไม่สามารถระบุช่วงเวลา 23:30 - 00:05",
    name_company_thai: "ชื่อบริษัท ภาษาไทย",
    name_company_eng: "ชื่อบริษัท ภาษาอังกฤษ",
    send_time_1: "สามารถนำส่งในช่วงเวลาดังกล่าวได้",
    send_time_2:
      "ช่วงเวลาดังกล่าวมีรอบการนำส่งสรรพากรครบตามที่กำหนดแล้ว กรุณาเลือกช่วงเวลาอื่น",
    send_time_3:
      "ระบบตั้งค่าการนำส่งเอกสารไปยังกรมสรรพากรขัดข้อง กรุณาติดต่อผู้ดูแลระบบ",

    swal: {
      notify_err: "โหลดข้อมูลไม่สำเร็จ",
      success: "สำเร็จ",
      mistake: "ผิดพลาด",
      setting_config: "ตั้งค่า Config เรียบร้อย",
      unable_setting_config: "ไม่สามารถตั้งค่า Config",
      incorrect_password: "รหัสผ่านไม่ถูกต้อง",
      setting_sms: "ตั้งค่า Service SMS เรียบร้อย",
      unable_setting_sms: "ไม่สามารถตั้งค่า Service SMS"
    },
    checkUserNoteSuccess: "สามารถนำส่งในช่วงเวลาดังกล่าวได้",
    checkUserNoteFull:
      "ช่วงเวลาดังกล่าวมีรอบการนำส่งสรรพากรครบตามที่กำหนดแล้ว กรุณาเลือกช่วงเวลาอื่น",
    checkUserNoteFail:
      "ระบบตั้งค่าการนำส่งเอกสารไปยังกรมสรรพากรขัดข้อง กรุณาติดต่อผู้ดูแลระบบ",
    type_list: [
      { value: "send_time", text: "ตั้งเวลา" },
      { value: "send_now", text: "นำส่งโดยทันที (เมื่อมีการสร้างข้อมูล e-tax)" }
    ],
    set_date: "ตั้งค่าวันที่",
    days_no: [
      { value: "01", text: "01" },
      { value: "02", text: "02" },
      { value: "03", text: "03" }, 
      { value: "04", text: "04" },
      { value: "05", text: "05" },
      { value: "06", text: "06" },
      { value: "07", text: "07" },
      { value: "08", text: "08" },
      { value: "09", text: "09" },
      { value: "10", text: "10" },
      { value: "11", text: "11" },
      { value: "12", text: "12" },
      { value: "13", text: "13" },
      { value: "14", text: "14" },
      { value: "15", text: "15" },
      // { value: "16", text: "16" },
      // { value: "17", text: "17" },
      // { value: "18", text: "18" },
      // { value: "19", text: "19" },
      // { value: "20", text: "20" },
      // { value: "21", text: "21" },
      // { value: "22", text: "22" },
      // { value: "23", text: "23" },
      // { value: "24", text: "24" },
      // { value: "25", text: "25" },
      // { value: "26", text: "26" },
      // { value: "27", text: "27" },
      // { value: "28", text: "28" },
      // { value: "29", text: "29" },
      // { value: "30", text: "30" },
      // { value: "31", text: "31" }
    ],
    set_time_hour: "ตั้งค่าเวลา (ชั่วโมง)",
    time_hours: [
      { value: "00", text: "00" },
      { value: "01", text: "01" },
      { value: "02", text: "02" },
      { value: "03", text: "03" },
      { value: "04", text: "04" },
      { value: "05", text: "05" },
      { value: "06", text: "06" },
      { value: "07", text: "07" },
      { value: "08", text: "08" },
      { value: "09", text: "09" },
      { value: "10", text: "10" },
      { value: "11", text: "11" },
      { value: "12", text: "12" },
      { value: "13", text: "13" },
      { value: "14", text: "14" },
      { value: "15", text: "15" },
      { value: "16", text: "16" },
      { value: "17", text: "17" },
      { value: "18", text: "18" },
      { value: "19", text: "19" },
      { value: "20", text: "20" },
      { value: "21", text: "21" },
      { value: "22", text: "22" },
      { value: "23", text: "23" }
    ],
    set_time_minute: "ตั้งค่าเวลา (นาที)",
    time_minute: [
      { value: "00", text: "00" },
      { value: "05", text: "05" },
      { value: "10", text: "10" },
      { value: "15", text: "15" },
      { value: "20", text: "20" },
      { value: "25", text: "25" },
      { value: "30", text: "30" },
      { value: "35", text: "35" },
      { value: "40", text: "40" },
      { value: "45", text: "45" },
      { value: "50", text: "50" },
      { value: "55", text: "55" }
    ],
    set_day: "ตั้งค่าวัน",
    days: [
      { value: "mon", text: "จันทร์" },
      { value: "tue", text: "อังคาร" },
      { value: "wed", text: "พุธ" },
      { value: "thu", text: "พฤหัสบดี" },
      { value: "fri", text: "ศุกร์" },
      { value: "sat", text: "เสาร์" },
      { value: "sun", text: "อาทิตย์" }
    ],
    // send_every: [
    //   {value:'Day', text:'วัน'},
    //   {value:'Week', text:'สัปดาห์'},
    //   {value:'Month', text:'เดือน'},
    // ],
    time: "เวลา",
    send_day: "ส่งทุกวันที่",
    of_each_month: "ของแต่ละเดือน",
    send_every_day: "ทุกวัน",
    send_every_week: "ทุกสัปดาห์",
    send_every_month: "ทุกเดือน",
    set_config: "ตั้งค่ารูปแบบการนำส่งข้อมูลสรรพากร",
    dialog_confirm: "ยืนยันการทำรายการ",
    dialog_confirm_note_1:
      "การ เปิด/ปิด ใช้งานการนำส่งข้อมูลสรรพากรอัตโนมัติ จำเป็นต้องมีการเก็บข้อมูล Password เพื่อเข้าถึง Token",
    dialog_confirm_note_2: "ต้องการดำเนินการต่อหรือไม่ ?",
    dialog_confirm_note_3:
      "หมายเหตุ: หากมีการอัพเดค Password จะต้องมา Config ใหม่ทุกครั้ง",
    dialog_confirm_note_4:
      "คำอธิบาย: สามารถดู Accesskey ได้จากเอกสารรายละเอียดที่ใช้ในการเชื่อมต่อ Service ที่ได้รับจากทาง INET",
    dialog_confirm_note_5:
      "หมายเหตุ: หากข้อมูลดังกล่าวมีการเปลี่ยนแปลง จะต้องมาตั้งค่าใหม่ทุกครั้ง",
    file_input_password: "กรุณากรอก password"
  },
  settingLicense: {
    title: "ตั้งค่าสิทธิ์การใช้งาน",
    menu: "เมนู",
    service: "บริการ",
    btn_save: "บันทึก",
    btn_cancle: "ยกเลิก",
    title_user: "User ที่มีสิทธิ์เข้าใช้งาน",
    access: "สิทธิ์เข้าใช้งาน",
    login: {
      title: "เข้าสู่ระบบต่างๆ",
      package: "เข้าสู่ระบบ Package",
      etax: "เข้าสู่ระบบ ETAX-SP"
    },
    etax_invoice: {
      full: "ใบกำกับภาษีแบบเต็ม",
      abb: "ใบกำกับภาษีแบบย่อ",
      dashbord: "ข้อมูลการใช้งาน",
      report: "รายงาน",
      ocr: "OCR",
      report_setting: "ตั้งค่ารายงาน",
      search_documents: "คัดค้นเอกสาร",
      instead: "เอกสารออกแทน",
      log: "Process log",
      email: "Email relay Report",
      listemail: "ข้อมูล Email ลูกค้า",
      logsendinvoicebyemail: "Logs ส่งเอกสารผ่านอีเมล",
      revenue: "นำส่งเอกสาร",
      revenue_status: "ตรวจสอบสถานะ",
      delete_transaction: "ลบเอกสารออกจากระบบ"
    },
    title_revenue: "การนำส่งสรรพากร",
    bill: {
      title: "สร้างบิล",
      create_etax: "สร้าง E-tax",
      list_create_etax: "รายการสร้าง E-tax",
      setting_number: "ตั้งค่าเลขที่เอกสาร",
      createCancleInstead: "ยกเลิกเอกสาร",
      createCreditNote: "สร้าง Credit Note",
      editTaxInvoice: "ออกแทนเอกสาร"
    },
    logsusage: "Logs การเข้าใช้งานระบบ",
    logsprintdocument: 'Logs พิมพ์เอกสาร',
    top_up: "เติมเงิน",
    manual: "คู่มือการใช้งาน",
    report: "แจ้งปัญหา",
    contact: "ติดต่อเรา",
    logout: "ออกจากระบบ",
    itemsFullMenu: [
      { value: "dashbord", text: "ข้อมูลการใช้งาน" },
      { value: "report", text: "รายงาน" },
      { value: "report_setting", text: "ตั้งค่ารายงาน" },
      { value: "search_documents", text: "คัดค้นเอกสาร" },
      { value: "instead", text: "เอกสารออกแทน" },
      { value: "processlog", text: "Process log" },
      { value: "email", text: "Email relay Report" },
      { value: "ocr", text: "OCR" },
      { value: "delete_transaction", text: "ลบเอกสารออกจากระบบ" }
    ],
    itemsAbbMenu: [
      { value: "dashbord", text: "ข้อมูลการใช้งาน" },
      { value: "report", text: "รายงาน" },
      { value: "report_setting", text: "ตั้งค่ารายงาน" },
      { value: "search_documents", text: "คัดค้นเอกสาร" }
    ],
    etax_invoice: {
      full: "ใบกำกับภาษีแบบเต็ม",
      abb: "ใบกำกับภาษีแบบย่อ"
    }
  },
  confirm: {
    title: "ยืนยันการนำส่งสรรพากร",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      button_delivery: "ยืนยันการนำส่ง",
      button_login: "เข้าสู่ระบบ",
      button_cancle: "ยกเลิก",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_title_send: "Service sendEBXML ไม่สามารถใช้งานได้",
      condition_subtitle: "ไม่สามารถนำส่งเอกสารในช่วง",
      condition_right_now: "ได้ในขณะนี้",
      condition_aleart: "คุณได้ยืนยันการนำส่งข้อมูลเรียบร้อยแล้ว",
      condition_subaleart: "คุณได้ยกเลิกการนำส่งข้อมูล",
      condition_titleLogin: "เข้าสู่ระบบ Web Portal",
      condition_subtitleLogin: "เพื่อยืนยันการนำส่งสรรพากร"
    },
    detail: {
      num_doc: "จำนวนเอกสาร",
      blade: "ใบ"
    },
    rules: {
      rules_username: "กรุณากรอก Username",
      rules_password: "กรุณากรอก Password",
      rules_taxid: "กรุณากรอก เลขประจำตัวผู้เสียภาษี",
      rules_numberFix: "ต้องมีจำนวนตัวเลขอย่างน้อย 13 หลัก"
    },

    swal: {
      mistake: "ผิดพลาด",
      server_err: "กรุณาติดต่อผู้ดูแลระบบ",
      unavailable: "ไม่สามารถใช้งานได้ในขณะนี้"
    }
  },
  mailrelayreport: {
    title: "Email Relay Report",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_excel: "ขอไฟล์ EXCEL",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      condition_date_pressing: "วันที่กดส่งเมลซ้ำอีกครั้ง",
      other: "อื่นๆ",
      tab_one: "Signing (ส่งเมลหลังจาก Signing)",
      tab_two: "Resend (ส่งเมลซ้ำ)",
      tab_three: "Group mail",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_fromemail: "วันที่ส่งอีเมล",
      condition_toemail: "ถึง",
      condition_fromdatemail: "วันที่ส่งเมลซ้ำ",
      condition_todatemail: "ถึง",
      send_system: [
        { text: "ทั้งหมด", value: "" },
        { text: "Signing", value: "signdocument" },
        { text: "Resend", value: "resend" }
      ],
      condition_test_system: "ประเภทการส่งอีเมล"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      doc_id: "เลขที่เอกสาร",
      status_email: "สถานะอีเมล",
      document_type: "ประเภทเอกสาร",
      list_data: "รายการ Email relay Report",
      email_from: "อีเมลผู้ส่ง",
      email_to: "อีเมลผู้รับ",
      detail: "รายละเอียด",
      timestamp: "เวลาที่ส่ง",
      status_email_send: "สถานะการส่งอีเมล",
      read: "เปิดอ่าน/ครั้ง",
      user_resend: "ผู้ใช้ที่ทำรายการ",
      status_process_email_send: "สถานะการดำเนินการ",
      select_file: "เลือกขอไฟล์",
      description: "รายละเอียด",
      tax_id: "Tax ID ผู้ซื้อ",
      buyer_name: "ชื่อผู้ซื้อ",
      resend_mail: "ส่งอีเมลอีกครั้ง",
      message: "รหัสข้อความ",
      no_data: "ไม่มีข้อมูล",
      seller_department: "แผนกผู้ขาย",
      document_date: "เอกสารลงวันที่",
      status: "สถานะ",
      file_size: "ขนาดไฟล์",
      err_message: "หมายเหตุ"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_text3: "Email ที่ส่งคราวที่เเล้ว",
      havemail_text4: "Email ใน Database",
      havemail_text5: "Email ใหม่",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?",
      notify_email_err: "ไม่พบเอกสารในระบบ ที่ใช้สำหรับส่งอีเมลซ้ำ",
      title_token: "Token ONE หมดอายุ",
      subtitle_token: "กรุณาเข้าสู่ระบบใหม่เพื่อรีเฟรช token",
      btn_cancle: "ยกเลิก",
      btn_logout: "ออกจากระบบ",
      alert_specify: "กรุณาระบุเงื่อนไข",
      docdate_resendate:
        "ช่วงเอกสารลงวันที่ หรือ ช่วงวันที่ส่งอีเมลซ้ำ อย่างใดอย่างหนึ่ง"
    },
    dialog_group_email: {
      title: "รายละเอียดข้อมูลเพิ่มเติม",
      close: "ปิด"
    }
  },
  resendmail: {
    title: "Email Relay Report",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_excel: "ขอไฟล์ EXCEL",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      condition_date_pressing: "วันที่กดส่งเมลซ้ำอีกครั้ง",
      other: "อื่นๆ",
      num: "จำนวน",
      order: "รายการ",

      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "null", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_fromemail: "วันที่ส่งอีเมล",
      condition_toemail: "ถึง",
      condition_fromdatemail: "วันที่ส่งเมลซ้ำ",
      condition_todatemail: "ถึง"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      doc_id: "เลขที่เอกสาร",
      status_email: "สถานะอีเมล",
      document_type: "ประเภทเอกสาร",
      list_data: "รายการ Email relay Report",
      email_from: "อีเมลผู้ส่ง",
      email_to: "อีเมลผู้รับ",
      timestamp: "เวลาที่ส่ง",
      status_email_send: "สถานะการส่งอีเมล",
      read: "เปิดอ่าน/ครั้ง",
      user_resend: "ผู้ใช้ที่ทำรายการ",
      status_process_email_send: "สถานะการดำเนินการ",
      select_file: "เลือกขอไฟล์",
      description: "รายละเอียด",
      tax_id: "Tax ID ผู้ซื้อ",
      buyer_name: "ชื่อผู้ซื้อ",
      resend_mail: "ส่งอีเมลอีกครั้ง",
      message: "รหัสข้อความ",
      no_data: "ไม่มีข้อมูล"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_text3: "Email ที่ส่งคราวที่เเล้ว",
      havemail_text4: "Email ใน Database",
      havemail_text5: "Email ใหม่",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?",
      notify_email_err: "ไม่พบเอกสารในระบบ ที่ใช้สำหรับส่งอีเมลซ้ำ",
      title_token: "Token ONE หมดอายุ",
      subtitle_token: "กรุณาเข้าสู่ระบบใหม่เพื่อรีเฟรช token",
      btn_cancle: "ยกเลิก",
      btn_logout: "ออกจากระบบ"
    }
  },
  dialog_download: {
    accesskey_text1: "กรุณากรอก accesskey",
    accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
    notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
    notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
    btn_confirm: "ยืนยัน",
    loading_download: "กำลังดาวน์โหลด.."
  },
  swal: {
    server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
    accesskey_err: "AccessKey ไม่ถูกต้อง",
    download_err: "ไม่สามารถโหลดไฟล์ได้",
    morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
    data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
    notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?"
  },
  dashbord: {
    title: "ข้อมูลการใช้งาน",
    numOfDoc: "จำนวนเอกสารทั้งหมด",
    storageAll: "พื้นที่ใช้งานตลอดสัญญา",
    billCurentMount: "จำนวนบิลที่ออกในเดือนนี้",
    billPerMonth: "จำนวนบิลในแต่ละเดือน",
    billPerHour: "จำนวนบิลในแต่ล่ะชั่วโมง",
    package: "ข้อมูลแพ็คเกจ",
    packages: "แพ็คเกจ",
    select: "เลือก",
    close: "ปิด",
    storageOfMonth: "Storage ที่ใช้ในเดือน",
    transactionInMonth: "Transactions ที่ใช้ในเดือน",
    transactionSuccess: "Transaction ที่สำเร็จ",
    transactionFail: "Transaction ที่ล้มเหลว",
    transactionDel: "Transaction ที่ลบ",
    transactionAll: "Transaction ทั้งหมด",
    transactionPerMounth: "จำนวน Transaction ต่อเดือน",
    textAlert: "ระบบจะอัพเดทข้อมูล ทุกเที่ยงคืนของวันถัดไป"
  },
  report_setting: {
    title: "ตั้งค่ารายงาน",
    manage_temp: "จัดการ Template",
    add_temp: "เพิ่ม Template",
    edit_temp: "แก้ไข Template",
    report_temp: "Template รายงาน",
    delete_temp: "ลบ Template",
    report_data: "ข้อมูลรายงาน",
    default: "ค่าเริ่มต้น",
    sample: "ตัวอย่างรายงาน",
    name_temp_rule: "กรุณาตั้งชื่อ Template",
    name_temp: "ชื่อ template",
    create_temp: "สร้าง Template",
    save_temp: "บันทึกข้อมูล Template",
    btn_save: "ยืนยัน",
    btn_cancle: "ยกเลิก",
    swal: {
      name_err: "กรุณาตั้งชื่อ Template ที่ต้องการสร้าง",
      data_report_err: "ไม่สามารถตั้งข้อมูลรายงานเกิน 13 คอลัมน์ได้",
      create_success: "สร้าง Template รายงานเรียบร้อย",
      create_err: "ไม่สามารถสร้าง Template รายงานได้ในขณะนี้",
      report_err: "ไม่สามารถเลือกข้อมูลรายงานได้เกิน 13 รายการ",
      edit_temp: "แก้ไข Template",
      success: "เรียบร้อย",
      temp_err: "ไม่สามารถแก้ไข Template รายงานได้ในขณะนี้",
      delete_default: "ไม่สามารถลบ Template Default ได้",
      delete_title: "คุณต้องการลบ Template ",
      or: "หรือไม่",
      delete_success: "ลบ Template รายงานเรียบร้อย",
      delete_err: "ไม่สามารถลบ Template ได้ในขณะนี้"
    }
  },
  keydetail: {
    details: "รายละเอียด",
    general: "ข้อมูลทั่วไป",
    filename: "ชื่อไฟล์",
    filesize: "ขนาดไฟล์",
    filetype: "ชนิดไฟล์",
    filedate: "วันที่อัพโหลด",
    closeDialog: "ปิด",
    owner: "เจ้าของ",
    month: {
      jan: "ม.ค.",
      feb: "ก.พ.",
      mar: "มี.ค.",
      apr: "เม.ษ.",
      may: "พ.ค.",
      jun: "มิ.ย.",
      jul: "ก.ค.",
      aug: "ส.ค.",
      sep: "ก.ย.",
      oct: "ต.ค.",
      nov: "พ.ย.",
      dec: "ธ.ค."
    }
  },
  resendmaillog: {
    header_table: {
      buyer_serial_no: "เลขผู้เสียภาษี (ผู้ซื้อ)",
      buyer_branch_id: "เลขที่สาขา (ผู้ซื้อ)",
      buyer_name: "ชื่อ (ผู้ซื้อ)",
      document_id: "เลขที่เอกสาร",
      document_date: "เอกสารลงวันที่",
      process_dtm: "วันที่ส่ง",
      email_from: "อีเมลผู้ขาย",
      email_to: "อีเมลผู้ซื้อ",
      type_code: "ประเภทเอกสาร",
      status_onebox: "สถานะส่งเข้า BOX",
      status: "สถานะส่งอีเมล",
      resentmail: "ส่งอีเมล์อีกครั้ง"
    }
  },
  create_bill: {
    title: "รายการสร้าง E-tax",
    btn_create_invoice: "สร้างเอกสาร",
    condition: {
      title: "เงื่อนไขในการค้นหา",
      condition_issue_date: "วันที่ออกเอกสาร",
      condition_toissuedate: "ถึง",
      condition_status: "สถานะ",
      condition_status_list: [
        { value: "", text: "ทั้งหมด" },
        { value: "0", text: "ฉบับร่าง" },
        { value: "4", text: "สร้างเอกสารสำเร็จ" }
      ],
      condition_search: "เลขที่เอกสาร, ชื่อผู้ซื้อ, ราคารวม",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      time: "เวลา",
      condition_search_up: "ค้นหาขั้นสูง"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :"
    },
    table: {
      header_no: "ลำดับ",
      header_doc_type: "ประเภทเอกสาร",
      header_doc_id: "เลขที่เอกสาร",
      header_buyer_name: "ชื่อผู้ซื้อ",
      header_tax_basis_total_amount: "มูลค่าสินค้า/บริการ",
      header_vat: "มูลค่าภาษี",
      header_grand_total: "มูลค่าสุทธิ",
      header_grand_total: "ราคารวม (บาท)",
      header_document_dtm: "เอกสารลงวันที่",
      header_etx_dtm: "วันที่สร้างเอกสาร",
      header_status: "สถานะ",
      header_user_create: "ผู้สร้าง"
    },
    dowloadind_data: "กำลังดาวน์โหลดข้อมูล...",
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?",
      no_data: "ไม่พบข้อมูลในระบบ",
      old_document: "เนื่องจากเป็นเอกสารเก่าในระบบ ก่อนการอัปเดทเมนูสร้างบิล",
      old_download: "ไม่สามารถดาว์นโหลดเอกสารได้",
      old_view: "ไม่สามารถดูเอกสารได้",
      old_del: "ไม่สามารถลบเอกสารได้",
      rd_sent: "เนื่องจากเอกสารอยู่ในสถานะนำส่งสรรพากร"
    },
  },
  create_invoice: {
    title: "สร้างเอกสาร",
    title_buyer_info: "ข้อมูลผู้ซื้อ",
    title_dialog: "ยืนยันการสร้างเอกสาร",
    sub_title_dialog:
      "กรุณาตรวจสอบข้อมูลก่อนสร้าง เนื่องจากหากมีการสร้างเอกสารแล้วจะไม่สามารถแก้ไขได้ ดำเนินการสร้าง",
    orNot: " หรือไม่ ?",
    note_dialog:
      " หมายเหตุ: กรุณากรอก Usercode และ Accesskeyสำหรับการสร้างเอกสารใช้งานครั้งแรก",
    button_home: "กลับสู่หน้าหลัก",
    chip_cancle: "ถูกยกเลิก",
    chip_draft: "ฉบับร่าง",
    chip_pending_payment: "รอชำระ",
    chip_waiting_review: "สร้างเอกสารไม่สำเร็จ",
    chip_paid: "กำลังประมวลผล",
    chip_success: "สร้างเอกสารสำเร็จ",
    btnAddContact: "เพิ่มข้อมูลผู้ซื้อ",
    btnSearch: "ค้นหาจากกรมสรรพากร",
    btnSearchRD: "ค้นหาจากกรม",
    nameCompany: "ชื่อ/บริษัท (ผู้ซื้อ)",
    titleSearch: "ค้นหาข้อมูลบริษัท จากฐานข้อมูลกรมสรรพากร",
    btnSearchData: "ค้นหา",
    lableTaxid: "ระบุ เลขประจำตัวผู้เสียภาษี",
    labelBuyerSearch: "กรอกชื่อผู้ซื้อ, Tax id, อีเมล, เบอร์โทรศัพท์",
    otp: "รหัส OTP ไม่ถูก",
    noteEmail: "* ระบุอีเมลหากต้องการนำส่งเอกสารไปยังอีเมลปลายทาง",
    noteSubEmail: "และใส่ comma(,) คั่น กรณีมีหลายอีเมล",
    pleaseSelect: "กรุณาเลือก",
    pleaseSelectSale: "กรุณาเลือกประเภทการขาย",
    tableSearch: {
      taxid: "เลขประจำตัวผู้เสียภาษี",
      nameCom: "ชื่อบริษัท",
      branchId: "เลขที่สาขา",
      address: "ที่อยู่",
      action: "ตัวเลือก",
      select: "เลือก"
    },
    condition: {
      title: "ข้อมูลเอกสาร",
      sub_title: "ข้อมูลใบแจ้งหนี้",
      button_add_product: "เพิ่มรายการสินค้า/บริการ",
      button_vat: "ภาษีหัก ณ ที่จ่าย",
      button_add_receiving: "เพิ่มบัญชีรับเงิน",
      button_upload_file: "อัปโหลดไฟล์",
      button_preview_pdf: "ดูตัวอย่าง PDF",
      button_create: "สร้าง",
      now: " ทันที",
      button_save: "บันทึกฉบับร่าง",
      button_saveAndCreate: "บันทึกและสร้าง ",
      button_send: "ส่งใบแจ้งหนี้",
      button_cancle: "ยกเลิก",
      button_confirm: "ยืนยัน",
      condition_buyer_name: "ชื่อผู้ซื้อ",
      condition_branchid: "เลขที่สาขา",
      condition_taxid: "เลขประจำตัวผู้เสียภาษี",
      condition_address: "ที่อยู่",
      condition_address_no: "เลขที่",
      condition_address_road: "ถนน",
      condition_address_sub_district: "แขวง",
      condition_address_district: "เขต",
      condition_address_thambol: "ตำบล",
      condition_address_amphur: "อำเภอ",
      condition_address_province: "จังหวัด",
      condition_address_postal_code: "รหัสไปรษณีย์",
      condition_address_tel: "โทร",
      condition_address_name_contact: "ชื่อผู้ติดต่อ",
      condition_invoice_id: "รหัสใบแจ้งหนี้",
      condition_doc_id: "เลขที่เอกสาร",
      condition_required: "* จำเป็นต้องกรอก",
      condition_issue_date: "เอกสารลงวันที่",
      rule_issue_date: "กรุณาเลือกเอกสารลงวันที่",
      condition_doc_type: "ประเภทเอกสาร",
      condition_example: "ตัวอย่าง : ค่าบริการรายเดือน",
      condition_listproduct: "รายการสินค้า / บริการ",
      condition_listproductItem: [
        { value: "0", text: "แยกภาษี" },
        { value: "1", text: "รวมภาษี" }
      ],
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_total_money: "รวมมูลค่า",
      condition_total: "รวมมูลค่า (บาท)",
      condition_discount_included: "มูลค่าส่วนลด",
      condition_price_discount: "มูลค่าก่อนภาษี",
      condition_value_without_tax: "มูลค่าที่ยกเว้นภาษี",
      condition_taxable: "มูลค่าที่คำนวณภาษี",
      condition_vat: "มูลค่าภาษี",
      condition_total_sum: "จำนวนเงินสุทธิ",
      condition_payment_channel: "ช่องทางการชำระเงิน",
      condition_additional_information: "ข้อมูลเพิ่มเติม",
      condition_additional_notes: "หมายเหตุเพิ่มเติม",
      condition_more_options: "ตัวเลือกเพิ่มเติม",
      condition_barcode_bank: "บาร์โค้ดชำระเงินผ่านธนาคาร",
      condition_without_tax: "หัก ณ ที่จ่าย",
      condition_amount_paid: "ยอดที่ต้องชำระ",
      condition_attachment: "เอกสารแนบ",
      condition_uploaded_file: "ไฟล์ที่อัปโหลดต้องมีขนาดไม่เกิน 5 MB",
      condition_tooltip:
        "หากบัญชีรับเงินของคุณมีการทำ Bill Paymenyt กับทางธนาคารไว้",
      condition_edm: "แสดงข้อความกำกับ การจัดทำเอกสารอิเล็กทรอนิกส์",
      condition_sub_tooltip:
        "คุณสามารถเปิดฟังก์ชันนี้เพื่อสร้างบาร์โค้ดสำหรับการชำระเงินลงใน PDF ได้",
      condition_rule_documentId: "กรุณากรอกเลขที่เอกสาร",
      condition_rule_documentType: "กรุณากรอกเลือกประเภทเอกสาร",
      condition_rule_detailProduct: "กรุณากรอกรายละเอียดสินค้า",
      condition_rule_amount: "กรุณากรอกจำนวน",
      condition_rule_price: "กรุณากรอกราคา/หน่วย",
      condition_rule_discount: "กรุณากรอกส่วนลด",
      condition_rule_tax: "เลือกภาษี",
      select_discount: "ประเภทส่วนลด",
      rule_issue_date: "กรุณาเลือกเอกสารลงวันที่",
      reason_delete: "เหตุผลการขอลบเอกสาร",
      condition_creditNoteTitle: "ข้อมูลสำหรับการออกใบลดหนี้ / เพิ่มหนี้",
      condition_docIdOld: "เลขที่เอกสารเดิม",
      condition_docDate: "วันที่เอกสารอ้างอิง",
      condition_docType: "ประเภทเอกสารอ้างอิง",
      condition_docNoteCode: "เหตุผลในการลดหนี้ Code",
      condition_docNote: "เหตุผลในการลดหนี้",
      condition_docValue: "มูลค่าตามใบกำกับภาษีเดิม",
      condition_additional_ref: "อ้างอิงเอกสาร",
      condition_note: "สาเหตุการทำอ้างอิง",
      condition_detail: "รายละเอียด(กรณีเลือกสาเหตุอื่นๆ)",
      condition_rule_docIdOld: "กรุณากรอกเลขที่เอกสารเดิม",
      condition_rule_docDate: "กรุณาระบุวันที่เอกสารอ้างอิง",
      condition_rule_docType: "กรุณาระบุประเภทเอกสารอ้างอิง",
      condition_rule_docNote: "กรุณากรอกเหตุผลในการลดหนี้",
      condition_rule_docNoteCode: "กรุณากรอกเหตุผลในการลดหนี้ Code",
      condition_rule_docValue: "กรุณากรอกมูลค่าตามใบกำกับภาษีเดิม",
      condition_rule_note: "กรุณาระบุสาเหตุการทำอ้างอิง",
      condition_additional_informationRule:
        "กรุณากรอกข้อมูลเพิ่มเติมไม่เกิน 500 ตัว",
      condition_productNameRule:
        "กรุณากรอกข้อมูลรายละเอียดสินค้าไม่เกิน 256 ตัว",
      condition_rule_po_number: "กรุณาระบุเลขที่คำสั่งซื้อ",
      condition_rule_rtv_number: "กรุณาระบุ RTV Number",
      condition_select_send: "ช่องทางการนำส่งตามที่กำหนดไว้",
      condition_select_one: "(เลือกได้เพียงหนึ่งช่องทาง)",
      condition_channel: "ช่องทางการส่งข้อมูลเพิ่มเติม",
      condition_send_doc: "*เมื่อเลือก ระบบจะส่งเอกสารผ่าน",
      condition_auto: "โดยอัตโนมัติ",
      condition_rule_note_no: "กรุณาระบุเลขที่ใบส่งคืนสินค้า",
    },
    dialog: {
      title: "เพิ่มวิธีการชำระเงิน",
      account_type: "ประเภทบัญชี",
      confirm_delete: "ยืนยันการลบ ข้อมูลผู้ซื้อ",
      dialogRef: "การระบุเอกสารอ้างอิง ระบบจะไม่มีการตรวจสอบว่าข้อมูลนั้นมีอยู่จริงหรือไม่ ยืนยันว่าข้อมูลอ้างอิงที่มาถูกต้องหรือไม่ ?",
      listaccountItem: [
        { value: "promptpay", text: "สแกน QR ผ่านบัญชีพร้อมเพย์" },
        { value: "bank", text: "โอนเงินผ่านบัญชีธนาคาร" }
      ],
      bankItems: [
        {
          value: "kk",
          name: "Kiatnakin Bank",
          image: require("@/assets/img/icon-bank/kiatnakin.png")
        },
        {
          value: "scb",
          name: "Siam Commercial Bank",
          image: require("@/assets/img/icon-bank/scb.png")
        },
        {
          value: "kbank",
          name: "Kasikorn Bank",
          image: require("@/assets/img/icon-bank/kbank.png")
        },
        {
          value: "ktb",
          name: "Krung Thai Bank",
          image: require("@/assets/img/icon-bank/krungthai.png")
        },
        {
          value: "bbl",
          name: "Bangkok Bank",
          image: require("@/assets/img/icon-bank/bangkok.png")
        },
        {
          value: "bay",
          name: "Bank of Ayudhya ",
          image: require("@/assets/img/icon-bank/krungsri.png")
        },
        {
          value: "gsb",
          name: "Government Savings bank",
          image: require("@/assets/img/icon-bank/aomsin.png")
        },
        {
          value: "tbank",
          name: "Thanachart Bank ",
          image: require("@/assets/img/icon-bank/tnc.png")
        },
        {
          value: "tmb",
          name: "TMB Bank ",
          image: require("@/assets/img/icon-bank/tmb.png")
        },
        {
          value: "uob",
          name: "United Overseas Bank",
          image: require("@/assets/img/icon-bank/uob.png")
        },
        {
          value: "sme",
          name: "Small and Medium Enterprise Development Bank of Thailand",
          image: require("@/assets/img/icon-bank/unnamed.png")
        }
      ],
      sub_title:
        "ระบบจะทำการสร้าง QR Code และแนบไปพร้อมกับรายการเรียกเก็บเงินที่ถูกส่งไปหาลูกค้าผ่านช่องทาง Email ทำให้ลูกค้าสามารถสแกนเพื่อชำระเงินได้",
      promptpay_number: "เลขที่พร้อมเพย์",
      account_name: "ชื่อบัญชี",
      bank_name: "ธนาคาร",
      account_number: "เลขที่บัญชี",
      explain: "สำหรับรายการที่ต้องการชำระเงินเป็นเช็ค หรือเงินสดเท่านั้น",
      button_add: "เพิ่ม",
      button_cancle: "ยกเลิก",
      note_email:
        "หมายเหตุ : กรุณากรอกอีเมลหากต้องการให้เอกสารนี้ส่งไปยังอีเมลผู้ซื้อ และหากต้องการส่งมากกว่า 1 อีเมลให้ใส่เครื่องหมาย , คั่นระหว่างอีเมล"
    },
    dialogBuyername: {
      title: "ข้อมูลผู้ซื้อ",
      contactData: "ข้อมูลผู้ติดต่อ",
      sellerid: "เลขประจำตัวผู้เสียภาษี ผู้ขาย",
      sub_title: "ที่อยู่ผู้ซื้อ",
      button_save: "บันทึก",
      button_close: "ปิด",
      button_add: "เพิ่มข้อมูลผู้ซื้อ",
      button_edit: "แก้ไข",
      button_delete: "ลบ",
      business_type: "ประเภทธุรกิจ",
      juristic_person: "นิติบุคคล",
      guest: "บุคคลทั่วไป",
      passport: "หนังสือเดินทาง",
      other: "อื่นๆ",
      buyer_name: "ชื่อผู้ซื้อ",
      branchid: "เลขที่สาขา",
      taxid: "เลขประจำตัวผู้เสียภาษี",
      taxid_tax: "เลขประจำตัวผู้เสียภาษี 13 หลัก",
      taxid_nidn: "เลขประจำตัวประชาชน 13 หลัก",
      taxid_ccpt: "เลขที่หนังสือเดินทาง",
      address: "ที่อยู่",
      address_no: "เลขที่",
      address_road: "ถนน",
      address_sub_district: "ตำบล/แขวง",
      address_district: "อำเภอ/เขต",
      address_province: "จังหวัด",
      address_postal_code: "รหัสไปรษณีย์",
      address_telephone: "โทรศัพท์",
      address_tel: "โทร",
      address_name_contact: "ชื่อผู้ติดต่อ",
      hint_address: "เลขที่, อาคาร, ถนน",
      email: "อีเมล",
      headOffice: "สำนักงานใหญ่",
      otherBranches: "สาขาอื่นๆ ",
      note:
        "หมายเหตุ : กรุณากรอกอีเมลหากต้องการให้เอกสารนี้ส่งไปยังอีเมลผู้ซื้อ และหากต้องการส่งมากกว่า 1 อีเมลให้ใส่เครื่อง , คั่นระหว่างอีเมล",
      rules_businessType: "กรุณาเลือก ประเภทธุรกิจ",
      rules_buyerName: "กรุณากรอก ชื่อผู้ซื้อ",
      rules_branch: "กรุณากรอก เลขที่สาขา",
      rules_taxid: "กรุณากรอก เลขประจำตัวผู้เสียภาษี",
      rules_numberFix: "ต้องมีจำนวนตัวเลขอย่างน้อย 13 หลัก",
      rules_numberFixbranch: "ต้องมีจำนวนตัวเลข 5 หลัก",
      invalid_email_format: "รูปแบบอีเมลไม่ถูกต้อง",
      address_building: "อาคาร",
      address_alley: "ซอย",
      address_floor_number: "ชั้นที่",
      address_moo_number: "หมู่ที่",
      address_room_number: "เลขที่ห้อง",
      address_village: "ชื่อหมู่บ้าน",
      pleaseBranchId: "ระบุสาขา",
      detail: "รายละเอียดเพิ่มเติม"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :"
    },
    table: {
      header_no: "ลำดับ",
      header_detail: "รายละเอียด",
      header_amount: "จำนวน",
      header_price: "ราคา/หน่วย (บาท)",
      header_discount: "ส่วนลด (บาท)",
      header_listdiscountItem: [
        { value: "baht", text: "บาท" },
        { value: "percent", text: "%" }
      ],
      header_vat: "ภาษี",
      header_total_price: "ราคารวม (บาท)",
      body_product: "สินค้า/บริการ",
      body_listvatItem: [{ value: 0, text: "0%" }, { value: 7, text: "7%" }]
    },
    dowloadind_data: "กำลังดาวน์โหลดข้อมูล...",
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?",
      no_data: "ไม่พบข้อมูลในระบบ",
      notify_taxid: "กรุณากรอกข้อมูล 'เลขประจำตัวผู้เสียภาษี'",
      notify_buyer: "กรุณากรอกข้อมูล 'ชื่อผู้ซื้อ'",
      notify_invoicename: "กรุณากรอกข้อมูล 'เลขที่เอกสาร'",
      notify_issue_date: "กรุณากรอกข้อมูล 'เอกสารลงวันที่'",
      notify_delete_product:
        "ไม่สามารถลบ 'รายการสินค้า/บริการ' น้อยกว่า 1 รายการได้",
      notify_fill_information: "กรุณากรอกข้อมูลให้ครบตามที่กำหนด",
      notify_confirm_document: "ยืนยันการดูตัวอย่างเอกสาร",
      notify_save_document: "คุณได้บันทึกเอกสารล่าสุดแล้วใช่ไหมหรือไม่ ? ",
      mistake: "ผิดพลาด",
      cannot_download_tem: "ไม่สามารถโหลด Template ได้",
      full_requrie: "กรุณาตรวจสอบข้อมูลให้ถูกต้องและตรบตามที่กำหนด",
      save_success: "บันทึกเอกสารสำเร็จ",
      reason_delete: "กรุณากรอกเหตุผลการลบเอกสาร",
      saveDraf: "บันทึกฉบับร่างสำเร็จ",
      no_juristic_person: "เนื่องจากข้อมูลไม่ใช่ประเภทนิติบุคคล",
      dateAlert:
      "กรณีที่ระบุวันที่เอกสารย้อนหลัง/ล่วงหน้า โปรดตรวจสอบความต่อเนื่องของเลขที่เอกสารก่อนทำรายการเสมอ !!",
    },
          mallType: [
        {
          text: "CENTRAL",
          value: "CENTRAL",
          image: require("@/assets/img/bill/central.svg"),
        },
        {
          text: "MAKRO",
          value: "MAKRO",
          image: require("@/assets/img/bill/mackro.svg"),
        },
        {
          text: "LOTUS’S",
          value: "LOTUS",
          image: require("@/assets/img/bill/lotus.svg"),
        },
        {
          text: "ผู้รับทั่วไป",
          value: "OTHER",
          image: require("@/assets/img/bill/other.png"),
        },
      ],
      salesType: [
        { text: "การขายประเภท CONSIGNMENT", value: "CSMT" },
        { text: "การขายประเภท CREDIT", value: "CRED" },
      ],
      salesTypeCPAll: [
        { text: "ลดหนี้ ณ วันที่ส่งมอบสินค้า", value: "Now" },
        { text: "ลดหนี้หลังวันที่ส่งมอบสินค้า", value: "After" },
      ],
  },
  edit_invoice: {
    title: "แก้ไขเอกสาร",
    button_edit: "บันทึกการแก้ไข",
    button_preview: "ดูตัวอย่าง",
    condition: {
      title: "ข้อมูลทั่วไป",
      sub_title: "ข้อมูลใบแจ้งหนี้",
      button_add_product: "เพิ่มรายการสินค้า/บริการ",
      button_vat: "ภาษีหัก ณ ที่จ่าย",
      button_add_receiving: "เพิ่มบัญชีรับเงิน",
      button_upload_file: "อัปโหลดไฟล์",
      button_preview_pdf: "ดูตัวอย่าง PDF",
      button_save: "บันทึกเป็นฉบับร่าง",
      button_send: "ส่งใบแจ้งหนี้",
      condition_buyer_name: "ชื่อผู้ซื้อ",
      condition_branchid: "เลขที่สาขา",
      condition_taxid: "เลขประจำตัวผู้เสียภาษี",
      condition_address: "ที่อยู่",
      condition_address_no: "เลขที่",
      condition_address_road: "ถนน",
      condition_address_sub_district: "ตำบล",
      condition_address_district: "อำเภอ",
      condition_address_province: "จังหวัด",
      condition_address_postal_code: "รหัสไปรษณีย์",
      condition_address_tel: "โทร",
      condition_address_name_contact: "ชื่อผู้ติดต่อ",
      condition_invoice_id: "รหัสใบแจ้งหนี้",
      condition_doc_id: "เลขที่เอกสาร",
      condition_required: "* จำเป็นต้องกรอก",
      condition_issue_date: "เอกสารลงวันที่",
      rule_issue_date: "กรุณาเลือกเอกสารลงวันที่",
      condition_doc_type: "ประเภทเอกสาร",
      condition_example: "ตัวอย่าง : ค่าบริการรายเดือน",
      condition_listproduct: "รายการสินค้า / บริการ",
      condition_listproductItem: [
        { value: "0", text: "แยกภาษี" },
        { value: "1", text: "รวมภาษี" }
      ],
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_total_money: "รวมมูลค่า",
      condition_discount_included: "มูลค่าส่วนลด",
      condition_price_discount: "มูลค่าก่อนภาษี",
      condition_value_without_tax: "มูลค่าที่ยกเว้นภาษี",
      condition_taxable: "มูลค่าที่คำนวณภาษี",
      condition_vat: "มูลค่าภาษี 7%",
      condition_total_sum: "รวมมูลค่าทั้งสิ้น",
      condition_payment_channel: "ช่องทางการชำระเงิน",
      condition_additional_information: "ข้อมูลเพิ่มเติม",
      condition_additional_notes: "หมายเหตุเพิ่มเติม",
      condition_more_options: "ตัวเลือกเพิ่มเติม",
      condition_barcode_bank: "บาร์โค้ดชำระเงินผ่านธนาคาร",
      condition_without_tax: "หัก ณ ที่จ่าย",
      condition_amount_paid: "ยอดที่ต้องชำระ",
      condition_attachment: "เอกสารแนบ",
      condition_uploaded_file: "ไฟล์ที่อัปโหลดต้องมีขนาดไม่เกิน 5 MB",
      condition_tooltip:
        "หากบัญชีรับเงินของคุณมีการทำ Bill Paymenyt กับทางธนาคารไว้",
      condition_sub_tooltip:
        "คุณสามารถเปิดฟังก์ชันนี้เพื่อสร้างบาร์โค้ดสำหรับการชำระเงินลงใน PDF ได้"
    },
    dialog: {
      title: "เพิ่มวิธีการชำระเงิน",
      account_type: "ประเภทบัญชี",
      listaccountItem: [
        { value: "scanPromptpay", text: "สแกน QR ผ่านบัญชีพร้อมเพย์" },
        { value: "bank", text: "โอนเงินผ่านบัญชีธนาคาร" }
        //   {value: 'pay', text: 'ชำระผ่านเช็ค หรือเงินสด'},
      ],
      bankItems: [
        {
          value: "kk",
          name: "Kiatnakin Bank",
          image: require("@/assets/img/icon-bank/kiatnakin.png")
        },
        {
          value: "scb",
          name: "Siam Commercial Bank",
          image: require("@/assets/img/icon-bank/scb.png")
        },
        {
          value: "kbank",
          name: "Kasikorn Bank",
          image: require("@/assets/img/icon-bank/kbank.png")
        },
        {
          value: "ktb",
          name: "Krung Thai Bank",
          image: require("@/assets/img/icon-bank/krungthai.png")
        },
        {
          value: "bbl",
          name: "Bangkok Bank",
          image: require("@/assets/img/icon-bank/bangkok.png")
        },
        {
          value: "bay",
          name: "Bank of Ayudhya ",
          image: require("@/assets/img/icon-bank/krungsri.png")
        },
        {
          value: "gsb",
          name: "Government Savings bank",
          image: require("@/assets/img/icon-bank/aomsin.png")
        },
        {
          value: "tbank",
          name: "Thanachart Bank ",
          image: require("@/assets/img/icon-bank/tnc.png")
        },
        {
          value: "tmb",
          name: "TMB Bank ",
          image: require("@/assets/img/icon-bank/tmb.png")
        },
        {
          value: "uob",
          name: "United Overseas Bank",
          image: require("@/assets/img/icon-bank/uob.png")
        },
        {
          value: "sme",
          name: "Small and Medium Enterprise Development Bank of Thailand",
          image: require("@/assets/img/icon-bank/unnamed.png")
        }
      ],
      sub_title:
        "ระบบจะทำการสร้าง QR Code และแนบไปพร้อมกับรายการเรียกเก็บเงินที่ถูกส่งไปหาลูกค้าผ่านช่องทาง Email ทำให้ลูกค้าสามารถสแกนเพื่อชำระเงินได้",
      promptpay_number: "เลขที่พร้อมเพย์",
      account_name: "ชื่อบัญชี",
      bank_name: "ธนาคาร",
      account_number: "เลขที่บัญชี",
      explain: "สำหรับรายการที่ต้องการชำระเงินเป็นเช็ค หรือเงินสดเท่านั้น",
      button_add: "เพิ่ม",
      button_cancle: "ยกเลิก"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :"
    },
    table: {
      header_no: "ลำดับ",
      header_detail: "รายละเอียด",
      header_amount: "จำนวน",
      header_price: "ราคา/หน่วย (บาท)",
      header_listdiscountItem: [
        { value: "baht", text: "บาท" },
        { value: "percent", text: "%" }
      ],
      header_vat: "ภาษี",
      header_total_price: "ราคารวม (บาท)",
      body_product: "สินค้า/บริการ",
      body_listvatItem: [{ value: 0, text: "0%" }, { value: 7, text: "7%" }]
    },
    dowloadind_data: "กำลังดาวน์โหลดข้อมูล...",
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?"
    }
  },
  view_invoice: {
    title: "ดูรายละเอียดเอกสาร",
    condition: {
      title: "ข้อมูลทั่วไป",
      sub_title: "ข้อมูลใบแจ้งหนี้",
      button_add_product: "เพิ่มรายการสินค้า/บริการ",
      button_vat: "ภาษีหัก ณ ที่จ่าย",
      button_add_receiving: "เพิ่มบัญชีรับเงิน",
      button_upload_file: "อัปโหลดไฟล์",
      button_preview_pdf: "ดูตัวอย่าง PDF",
      button_save: "บันทึกเป็นฉบับร่าง",
      button_send: "ส่งใบแจ้งหนี้",
      button_cancle: "ยกเลิก",
      button_confirm: "ยืนยัน",
      condition_buyer_name: "ชื่อผู้ซื้อ",
      condition_branchid: "เลขที่สาขา",
      condition_taxid: "เลขประจำตัวผู้เสียภาษี",
      condition_address: "ที่อยู่",
      condition_address_no: "เลขที่",
      condition_address_road: "ถนน",
      condition_address_sub_district: "ตำบล/แขวง",
      condition_address_district: "อำเภอ/เขต",
      condition_address_province: "จังหวัด",
      condition_address_postal_code: "รหัสไปรษณีย์",
      condition_address_tel: "โทร",
      condition_address_name_contact: "ชื่อผู้ติดต่อ",
      condition_doc_id: "เลขที่เอกสาร",
      condition_required: "* จำเป็นต้องกรอก",
      condition_issue_date: "วันที่ออกเอกสาร",
      rule_issue_date: "กรุณาเลือกเอกสารลงวันที่",
      condition_doc_type: "ประเภทเอกสาร",
      condition_example: "ตัวอย่าง : ค่าบริการรายเดือน",
      condition_listproduct: "รายการสินค้า / บริการ",
      condition_listproductItem: [
        { value: "0", text: "แยกภาษี" },
        { value: "1", text: "รวมภาษี" }
      ],
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_total_money: "รวมเป็นเงิน",
      condition_total: "รวมเป็นเงิน (บาท)",
      condition_discount_included: "รวมส่วนลด",
      condition_price_discount: "ราคาหลังหักส่วนลด",
      condition_value_without_tax: "มูลค่าที่ไม่มี/ยกเว้นภาษี",
      condition_taxable: "มูลค่าที่เสียภาษี",
      condition_vat: "ภาษีมูลค่าเพิ่ม",
      condition_total_sum: "จำนวนเงินสุทธิ",
      condition_payment_channel: "ช่องทางการชำระเงิน",
      condition_additional_information: "ข้อมูลเพิ่มเติม",
      condition_additional_notes: "หมายเหตุเพิ่มเติม",
      condition_more_options: "ตัวเลือกเพิ่มเติม",
      condition_barcode_bank: "บาร์โค้ดชำระเงินผ่านธนาคาร",
      condition_without_tax: "หัก ณ ที่จ่าย",
      condition_amount_paid: "ยอดที่ต้องชำระ",
      condition_attachment: "เอกสารแนบ",
      condition_uploaded_file: "ไฟล์ที่อัปโหลดต้องมีขนาดไม่เกิน 5 MB",
      condition_tooltip:
        "หากบัญชีรับเงินของคุณมีการทำ Bill Paymenyt กับทางธนาคารไว้",
      condition_edm: "แสดงข้อความกำกับ การจัดทำเอกสารอิเล็กทรอนิกส์",
      condition_sub_tooltip:
        "คุณสามารถเปิดฟังก์ชันนี้เพื่อสร้างบาร์โค้ดสำหรับการชำระเงินลงใน PDF ได้"
    },
    dialog: {
      title: "เพิ่มวิธีการชำระเงิน",
      account_type: "ประเภทบัญชี",
      listaccountItem: [
        { value: "promptpay", text: "สแกน QR ผ่านบัญชีพร้อมเพย์" },
        { value: "bank", text: "โอนเงินผ่านบัญชีธนาคาร" }
      ],
      bankItems: [
        {
          value: "kk",
          name: "Kiatnakin Bank",
          image: require("@/assets/img/icon-bank/kiatnakin.png")
        },
        {
          value: "scb",
          name: "Siam Commercial Bank",
          image: require("@/assets/img/icon-bank/scb.png")
        },
        {
          value: "kbank",
          name: "Kasikorn Bank",
          image: require("@/assets/img/icon-bank/kbank.png")
        },
        {
          value: "ktb",
          name: "Krung Thai Bank",
          image: require("@/assets/img/icon-bank/krungthai.png")
        },
        {
          value: "bbl",
          name: "Bangkok Bank",
          image: require("@/assets/img/icon-bank/bangkok.png")
        },
        {
          value: "bay",
          name: "Bank of Ayudhya ",
          image: require("@/assets/img/icon-bank/krungsri.png")
        },
        {
          value: "gsb",
          name: "Government Savings bank",
          image: require("@/assets/img/icon-bank/aomsin.png")
        },
        {
          value: "tbank",
          name: "Thanachart Bank ",
          image: require("@/assets/img/icon-bank/tnc.png")
        },
        {
          value: "tmb",
          name: "TMB Bank ",
          image: require("@/assets/img/icon-bank/tmb.png")
        },
        {
          value: "uob",
          name: "United Overseas Bank",
          image: require("@/assets/img/icon-bank/uob.png")
        },
        {
          value: "sme",
          name: "Small and Medium Enterprise Development Bank of Thailand",
          image: require("@/assets/img/icon-bank/unnamed.png")
        }
      ],
      sub_title:
        "ระบบจะทำการสร้าง QR Code และแนบไปพร้อมกับรายการเรียกเก็บเงินที่ถูกส่งไปหาลูกค้าผ่านช่องทาง Email ทำให้ลูกค้าสามารถสแกนเพื่อชำระเงินได้",
      promptpay_number: "เลขที่พร้อมเพย์",
      account_name: "ชื่อบัญชี",
      bank_name: "ธนาคาร",
      account_number: "เลขที่บัญชี",
      explain: "สำหรับรายการที่ต้องการชำระเงินเป็นเช็ค หรือเงินสดเท่านั้น",
      button_add: "เพิ่ม",
      button_cancle: "ยกเลิก"
    },
    dialogBuyername: {
      title: "ข้อมูลผู้ซื้อ",
      sub_title: "ที่อยู่ผู้ซื้อ",
      button_save: "ตกลง",
      button_add: "เพิ่มข้อมูลผู้ซื้อ",
      button_edit: "แก้ไขข้อมูลผู้ซื้อ",
      button_delete: "ลบข้อมูลผู้ซื้อ",
      business_type: "ประเภทธุรกิจ",
      juristic_person: "นิติบุคคล",
      guest: "บุคคลทั่วไป",
      buyer_name: "ชื่อผู้ซื้อ",
      branchid: "เลขที่สาขา",
      taxid: "เลขประจำตัวผู้เสียภาษี",
      address: "ที่อยู่",
      address_no: "เลขที่",
      address_road: "ถนน",
      address_sub_district: "ตำบล/แขวง",
      address_district: "อำเภอ/เขต",
      address_province: "จังหวัด",
      address_postal_code: "รหัสไปรษณีย์",
      address_telephone: "โทรศัพท์",
      address_tel: "โทร",
      address_name_contact: "ชื่อผู้ติดต่อ",
      hint_address: "เลขที่, อาคาร, ถนน",
      email: "อีเมล"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :"
    },
    table: {
      header_no: "ลำดับ",
      header_detail: "รายละเอียด",
      header_amount: "จำนวน",
      header_price: "ราคา/หน่วย (บาท)",
      header_discount: "ส่วนลด (บาท)",
      header_listdiscountItem: [
        { value: "baht", text: "บาท" },
        { value: "percent", text: "%" }
      ],
      header_vat: "ภาษี",
      header_total_price: "ราคารวม (บาท)",
      body_product: "สินค้า/บริการ",
      body_listvatItem: [{ value: 0, text: "0%" }, { value: 7, text: "7%" }]
    },
    dowloadind_data: "กำลังดาวน์โหลดข้อมูล...",
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?",
      no_data: "ไม่พบข้อมูลในระบบ",
      notify_taxid: "กรุณากรอกข้อมูล 'เลขประจำตัวผู้เสียภาษี'",
      notify_buyer:
        "กรุณากรอกข้อมูล 'เลขประจำตัวผู้เสียภาษีและชื่อ' ของผู้ซื้อ ",
      notify_invoicename: "กรุณากรอกข้อมูล 'เลขที่เอกสาร'"
    }
  },
  settingsigning: {
    title: "ตั้งค่าตำแหน่ง Signing",
    condition: {
      btn_add: "เพิ่มตำแหน่ง"
    },
    dialog: {
      copy_title: "คัดลอกตำแหน่ง",
      copy_sub_title: "คุณต้องการคัดลอกตำแหน่ง",
      copy_to: "ไปยัง",
      delete_title: "ยืนยันการลบ ?",
      delete_sub_title_1: "คุณต้องการลบ",
      delete_sub_title_2: "ออกจากระบบหรือไม่"
    },
    table: {
      header_no: "ลำดับ",
      header_doc_type: "ประเภทเอกสาร",
      header_position: "เลขทีตำแหน่ง",
      header_user: "ผู้สร้าง",
      header_active: "การใช้งาน",
      header_action: "Action"
    },
    tools: {
      table: "ตาราง",
      inputbox: "กล่องป้อนข้อมูล",
      textfield: "กล่องข้อความ",
      image: "รูปภาพ",
      line: "เส้น",
      Rectangle: "กรอบ"
    }
  },
  addpositionsigning: {
    title: "เพิ่มตำแหน่ง Signing",
    edittitle: "แก้ไขตำแหน่ง Signing",
    condition: {
      title_upload: "คลิกเพื่ออัพโหลดไฟล์ PDF",
      width: "ความกว้าง",
      height: "ความสูง",
      btn_upload: "อัปโหลดไฟล์ใหม่",
      btn_save: "บันทึก",
      btn_accept: "ยืนยัน",
      btn_cancle: "ยกเลิก",
      btn_edit: "แก้ไข",
      btn_delete: "ลบ",
      btn_copy: "คัดลอก",
      btn_show: "เปิดใช้งาน",
      btn_off: "ปิด"
    }
  },
  dialogEmail: {
    attachAdditionalFiles: "แนบไฟล์เพิ่มเติม",
    attachFiles: "คลิกเพื่อแนบไฟล์เพิ่มเติม",
    email: "อีเมล",
    noteEtc: "หมายเหตุ : จะแนบไฟล์เพิ่มเติมสำหรับทุกรายการอีเมล",
    ruleFiles: "ขนาดไฟล์รวมควรน้อยกว่า 15 MB",
    fileNotSupported: "ไม่รองรับการแนบไฟล์เพิ่มเติม",
    checkEmail: "ตรวจสอบอีเมล...",
    checkComplete: "กำลังตรวจสอบ",
    checkFail: "ไม่สามารถกดนำส่งได้",
    checkSuccess: "สามารถกดนำส่งได้",
    from: "จาก",
    unit: "รายการ",
    sendFileto: "คุณต้องการส่งไฟล์",
    btnSave: "ยืนยัน",
    btnCancle: "ปิด",
    noEmail: "ไม่พบประวัติการส่งอีเมลสำหรับเอกสารที่เลือก",
    btnAddEmail: "เพิ่มอีเมล",
    resend: "อีกครั้งใช่หรือไม่?",
    number: "จำนวน",
    etc:
      "หมายเหตุ: สามารถใช้เครื่องหมาย , (จุลภาค) หากต้องการส่งมากกว่า 1 อีเมล",
    note: "หมายเหตุ: รายการที่ตรวจสอบไม่สำเร็จจะไม่สามารถกดส่งอีเมลได้",
    note1: "กรุณเลือกรายการใหม่ เพื่อตรวจสอบอีกครั้ง",
    close: "ปิด",
    sendSuccess: "นำส่งอีเมลสำเร็จ",
    success: "สำเร็จ!",
    notfoundDoc: "ไม่พบเอกสารในระบบ",
    tokenTitle: "Token ONE หมดอายุ",
    tokenText: "กรุณาเข้าสู่ระบบใหม่เพื่อรีเฟรช token",
    tokenBtnConfirm: "ออกจากระบบ",
    tokenBtnCancle: "ยกเลิก",
    regex: "รูปแบบอีเมลไม่ถูกต้อง",
    listEmail: "รายการนำส่งอีเมล",
    sendding: "กำลังนำส่ง",
    senddingSuccess: "นำส่งสำเร็จ",
    senddingFails: "นำส่งล้มเหลว",
    id: "เลขที่",
    viewFile: "ดูรายละเอียด",
    hideFile: "ซ่อนรายละเอียด",
    table: {
      no: "ลำดับ",
      documentId: "เลขที่เอกสาร",
      resendMail: "อีเมลผู้รับ",
      status: "สถานะ",
      errorMessage: "หมายเหตุ",
      doc_type: "ประเภทเอกสาร",
      buyer_name: "ชื่อผู้ซื้อ",
      file: "ไฟล์แนบเพิ่มเติม",
      nameFile: "ชื่อไฟล์",
      size: "ขนาด"
    },
    btnSaveEmail: "ยืนยันการส่งอีเมล",
    btnFile: "แนบไฟล์",
    label_attachFileAll: "แนบไฟล์เพิ่มเติมทั้งหมด",
    label_attachFileDispart: "แนบไฟล์เพิ่มเติมแยกตามอีเมล",
    tabName: "รายละเอียดข้อมูล",
    textDetailAttach: "รายละเอียดแนบไฟล์",
    labelFileInput: "คลิกเลือกไฟล์"
  },
  dialogChat: {
    sendFileto: "คุณต้องการส่งไฟล์",
    btnSave: "ยืนยัน",
    btnCancle: "ยกเลิก",
    noOnechat: "ไม่พบประวัติการส่ง Onechat สำหรับเอกสารที่เลือก",
    btnAddOnechat: "เพิ่มเบอร์โทรศัพท์",
    resend: "อีกครั้งใช่หรือไม่?",
    sendSuccess: "ส่ง Onechat สำเร็จ",
    success: "สำเร็จ!"
  },
  dialogSMS: {
    sendFileto: "คุณต้องการส่งไฟล์",
    btnSave: "ยืนยัน",
    btnCancle: "ยกเลิก",
    noSMS: "ไม่พบประวัติการส่ง SMS สำหรับเอกสารที่เลือก",
    btnAddEmail: "เพิ่มเบอร์โทรศัพท์",
    resend: "อีกครั้งใช่หรือไม่?",
    sendSuccess: "ส่ง SMS สำเร็จ",
    success: "สำเร็จ!",
    phoneNumber: "เบอร์โทรศัพท์",
    rulePhonenumber: "กรุณากรอก เบอร์โทรศัพท์",
    fixPhonenumber: "ต้องมีจำนวนตัวเลขอย่างน้อย 10 หลัก"
  },
  dialogMailrelayCount: {
    no: "ลำดับ",
    read: "เวลาที่เปิดอ่าน",
    detail: "รายละเอียดข้อมูล",
    close: "ปิด"
  },
  dialogSftp: {
    downloading: "กำลังดาวน์โหลด...",
    deleting: "กำลังลบเอกสาร...",
    moving: "กำลังย้ายเอกสาร...",
    deleteTitle: "ยืนยันการลบ",
    deleteDetail: "คุณต้องการลบ ",
    deleteAsk: " หรือไม่",
    deleteSuccess: "ลบรายการเอกสารสำเร็จ",
    duplicateFile: "พบไฟล์ซ้ำ ",
    replaceFile: "คุณต้องการแทนที่ไฟล์ดังกล่าวหรือไม่",
    duplicateNameFile: "ชื่อไฟล์/โฟลเดอร์ ซ้ำ",
    closeBtn: "ปิด",
    saveBtn: "บันทึก",
    moveBtn: "ย้าย",
    confirmBtn: "ยืนยัน",
    cancleBtn: "ยกเลิก",
    setting: "ตั้งค่า",
    profile: "ข้อมูลส่วนตัว",
    editPassword: "แก้ไขรหัสผ่าน",
    passwordNow: "รหัสผ่านปัจจุบัน",
    passwordNew: "รหัสผ่านใหม่",
    inputPasswordNow: "กรุณากรอกรหัสผ่านปัจจุบัน",
    inputPasswordNew: "กรุณากรอกรหัสผ่านใหม่",
    inputPasswordConfirm: "ยืนยันรหัสผ่านใหม่",
    PasswordCheck: "กรุณากรอกรหัสผ่านให้ตรงกัน",
    hour: "ชั่วโมง",
    minute: "นาที",
    excelBtn: "ตั้งค่า ข้อมูล excel",
    backBtn: "ย้อนกลับ",
    addConfig: "เพิ่ม config",
    editConfirm: "ยืนยันการแก้ไขข้อมูล",
    selectServiceCode: "เลือก Service code",
    selectConfig: "เลือก Service Config",
    checkConfigname: "กรุณากรอก Config name",
    checkHour: "กรุณากรอก ชั่วโมง",
    checkMinute: "กรุณากรอก นาที",
    checkServiceCode: "กรุณาเลือก Service code",
    checkConfig: "กรุณาเลือก Service config",
    checkUsercode: "กรุณากรอก Usercode",
    checkAccesskey: "กรุณากรอก Accesskey",
    checkEmail: "กรุณากรอก อีเมล",
    checkPassword: "กรุณากรอกรหัสผ่าน",
    checkPasswordConfirm: "กรุณากรอกรหัสผ่านยืนยัน",
    uploadFile: "อัพโหลดไฟล์",
    uploadFileLabel: "ไฟล์ที่ต้องการอัพโหลด",
    selectFile: "กรุณาเลือกไฟล์ที่ต้องการอัพโหลด",
    uploadFail: "อัพโหลดไฟล์ล้มเหลว...",
    uploadFailDetail: "สามารถอัพโหลดไฟล์ได้ครั้งล่ะไม่เกิน 100 ไฟล์",
    uploadPending: "กำลังรออัพโหลด",
    uploadProgress: "กำลังอัพโหลดไฟล์...",
    uploadDone: "อัพโหลดไฟล์สำเร็จ",
    fileNotAccept: "ไฟล์ไม่รองรับ",
    fileCatch: "ไม่สามารถอัพโหลดไฟล์ได้ในขณะนี้",
    uploadFolder: "สร้างโฟลเดอร์",
    checkFolder: "กรุณากรอกชื่อ โฟลเดอร์",
    duplicateFolder: "มีโฟลเดอร์นี้์อยู่แล้ว",
    settingExcelColRow: "ตั้งค่า คอลัมน์/แถว ของข้อมูล",
    settingExcelTypedoc: "รูปแบบเอกสาร:",
    settingExcelTypedocLabel: "เลือกรูปแบบเอกสาร",
    settingExcelCategory: "ประเภทเอกสาร:",
    settingExcelCategoryLabel: "เลือกประเภทเอกสาร",
    settingExcelDetails: "รายละเอียดการตังค่า:",
    settingExcelDetails1:
      "คอลัมน์: ตัวอักษร A-Z , แถว: ตัวเลขจำนวนเต็ม 1-999...",
    settingExcelSeller: "ข้อมูลผู้ขาย :",
    settingExcelTypeinput: "ประเภทข้อมูล",
    settingExcelInputDetail: "คอมลัมน์และแถว",
    settingExcelDoc: "ข้อมูลเอกสาร :",
    settingExcelBuyer: "ข้อมูลผู้ซื้อ :",
    settingExcelLineitem: "ข้อมูลรายการสินค้า :",
    settingExcelSUMMARY: "ข้อมูลสรุปสินค้า :",
    settingExcelRequird: "กรุณากรอกข้อมูลที่จำเป็นให้ครบทุกช่อง",
    settingColRow: "ตั้งค่า คอลัมน์/แถว ของข้อมูล"
  },
  sftpSetting: {
    setting: "ตั้งค่า",
    account: "ข้อมูลส่วนตัว",
    settingConfig: "ตั้งค่า Config",
    editPassword: "แก้ไขรหัสผ่าน",
    cancle: "ยกเลิก",
    save: "บันทึก",
    confirm: "ยืนยัน",
    confirmData: " ยืนยันการแก้ไขข้อมูล",
    passwordNow: "รหัสผ่านปัจจุบัน",
    passwordNew: "รหัสผ่านใหม่",
    placeholderPassword: "กรุณากรอกรหัสผ่าน",
    placeholderPasswordNow: "กรุณากรอกรหัสผ่านปัจจุบัน",
    placeholderPasswordNew: "กรุณากรอกรหัสผ่านใหม่",
    placeholderconfirmPassword: "ยืนยันรหัสผ่าน",
    selectServiceCode: "เลือก Service code",
    ruleconfigName: "กรุณากรอก Config name",
    rulepathInput: "กรุณาเลือก Path input",
    rulepathOutput: "กรุณาเลือก Path output",
    ruleHour: "กรุณากรอก ชั่วโมง",
    ruleMin: "กรุณากรอก นาที",
    ruleServiceCode: "กรุณาเลือก Service code",
    ruleServiceConfig: "กรุณาเลือก Service config",
    ruleUsercode: "กรุณากรอก Usercode",
    ruleAccesskey: "กรุณากรอก Accesskey",
    ruleEmail: "กรุณากรอก Email",
    ruleConfirmpass: "กรุณากรอกรหัสผ่านยืนยัน",
    samePassword: "กรุณากรอกรหัสผ่านให้ตรงกัน",
    addConfig: "เพิ่ม Config",
    nameConfig: "ชื่อ Config",
    status: "สถานะ",
    manage: "จัดการ",
    nameSetting: "ชื่อการตั้งค่า",
    dutyCycle: "รอบการทำงาน",
    each: "ทุก",
    hour: "ชั่วโมง",
    min: "นาที",
    importDataFormat: "รูปแบบข้อมูลนำเข้า",
    settingExcel: "ตั้งค่า ข้อมูล excel",
    back: "ย้อนกลับ",
    itemsServiceCode: [
      { value: null, text: "เลือก Service code" },
      { value: "S03", text: "S03 - CSV " },
      { value: "S06", text: "S06 - CSV และ PDF" },
      { value: "S11", text: "S11 - CSV โดยไม่ส่ง e-mail" },
      // { value: "E03", text: "EXCEL (S03)" },
      { value: "E06", text: "EXCEL(Template) - Excel รูปแบบ Template" },
      { value: "S46", text: "S46 - CSV โดยเช็คเอกสารซ้ำ" }
    ],
    table: {
      nameConfig: "ชื่อ Config",
      status: "สถานะ",
      manage: "จัดการ"
    },
    swal: {
      deleteTitle: "ยืนยันการลบ",
      deleteSub: "คุณต้องการลบ Config:",
      orNot: "หรือไม่"
    }
  },
  sftpIndex: {
    setting: "ตั้งค่า",
    logout: "ออกจากระบบ",
    download: "ดาวน์โหลด",
    delete: "ลบ",
    move: "ย้าย",
    confirm: "ยืนยัน",
    cancle: "ยกเลิก",
    search: "ค้นหา ชื่อไฟล์/โฟลเดอร์",
    fileUpload: "วางไฟล์เพื่อทำการอัพโหลด",
    duplicateFile: "พบไฟล์ซ้ำ",
    selectFile: "กรุณาเลือกไฟล์ที่ต้องการแทนที่",
    selectAll: "เลือกทั้งหมด",
    cross: "ข้าม",
    instead: "แทนที่",
    deleteDocument: "กำลังลบเอกสาร... ",
    generateFile: "กำลัง Generate file...",
    uploading: "กำลังอัพโหลด..",
    selectServiceCode: "เลือก Service code",
    dowloadingFile: "กำลังดาวน์โหลดไฟล์",
    selected: "เลือกแล้ว",
    waitingUpload: "กำลังรออัพโหลด",
    uploadingFile: "กำลังอัพโหลดไฟล์",
    uploadComplete: "อัพโหลดไฟล์เสร็จสมบูรณ์",
    uploadSuccess: "อัพโหลดไฟล์สำเร็จ",
    fileNotSupported: "ไฟล์ไม่รองรับ",
    serverErr: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
    configS06:
      "เนื่องจาก Config เป็น S06 กรุณาอัพโหลดไฟล์ ให้ตรงตาม Config ไฟล์ที่รองรับคือ (.pdf, .txt, .csv)",
    becauseConfig: "เนื่องจาก Config เป็น",
    uploadConfigTxt:
      "กรุณาอัพโหลดไฟล์ ให้ตรงตาม Config ไฟล์ที่รองรับคือ (.txt, .csv)",
    uploadConfigXlsx:
      " กรุณาอัพโหลดไฟล์ ให้ตรงตาม Config ไฟล์ที่รองรับคือ (.xlsx,.xls)",
    cannotUpload500: "ไม่สามารถอัพโหลดไฟล์ขนาด เกิน 500MB ได้",
    table: {
      fileName: "ชื่อไฟล์/โฟลเดอร์",
      owner: "เจ้าของ",
      lastdtm: "วันที่อัพโหลด",
      size: "ขนาด",
      action: "จัดการไฟล์"
    },
    swal: {
      generateSuccess: "Generate e-Tax สำเร็จ",
      confirmDelete: "ยืนยันการลบ",
      wantDeleteFile: "คุณต้องการลบไฟล์จำนวน",
      list: "รายการหรือไม่",
      deleteSuccess: "ลบรายการเอกสารสำเร็จ",
      uploadFail: "อัพโหลดไฟล์ล้มเหลว...",
      uploadFile: "สามารถอัพโหลดไฟล์ได้ครั้งล่ะไม่เกิน 100 ไฟล์"
    }
  },
  sftpLogin: {
    noAccount: "ยังไม่มี Account ใช่หรือไม่?",
    register: "สมัครสมาชิก",
    forgerPassword: "ลืมรหัสผ่าน?",
    login: "เข้าสู่ระบบ",
    confirm: "ยืนยัน",
    cancle: "ยกเลิก",
    otpEmail:
      "*** OTP ถูกส่งไปยัง email ที่ได้ลงทะเบียนไว้กับระบบ SFTP และจะมีอายุการใช้งาน 15 นาที",
    requestOtp: "ขอ OTP ใหม่",
    settingPassword: "ตั้งค่ารหัสผ่านใหม่",
    placeholderPassword: "กรุณากรอกรหัสผ่าน",
    placeholderPasswordAgain: "กรุณากรอกรหัสผ่านอีกครั้ง",
    success: "สำเร็จ",
    fail: "ไม่สำเร็จ",
    loginSuccess: "เข้าสู่ระบบสำเร็จ",
    server_err: "ไม่สามารถเชื่อมต่อเซิฟเวอร์ได้",
    passwordSame: "กรุณากรอกรหัสผ่านให้ตรงกัน",
    pleaseFillOut: "กรุณากรอกข้อมูล",
    usernameReset: "Username เพื่อใช้สำหรับ reset รหัสผ่าน",
    changePassword: "เปลี่ยนรหัสผ่านสำเร็จ",
    swalTitle: "จำเป็นต้องมีการยืนยัน OTP เพื่อเปลี่ยนรหัสผ่านใหม่",
    swalSubTitle:
      "(หมายเหตุ: OTP จะถูกส่งไปยังอีเมลที่เคยสมัครกับระบบ SFTP-FTP)",
    rules_username: "กรุณากรอก Username",
    rules_password: "กรุณากรอก Password",
    rules_otp: "กรุณากรอก OTP"
  },
  sftpRegister: {
    registerSftp: "สมัครสมาชิกสำหรับการใช้งาน SFTP-FTP",
    note:
      "หมายเหตุ: สามารถดู accesskey ได้จากเอกสารรายละเอียดที่ใช้ในการเชื่อมต่อ Service ที่ได้รับจากทาง INET",
    back: "ย้อนกลับ",
    register: "สมัครสมาชิก",
    rules_username: "กรุณากรอก Username",
    rules_password: "กรุณากรอก Password",
    rules_usercode: "กรุณากรอก usercode",
    rules_name: "กรุณากรอก ชื่อ",
    rules_lastname: "กรุณากรอก นามสกุล",
    rules_email: "กรุณากรอก อีเมล",
    rules_tel: "กรุณากรอก เบอร์โทรศัพท์",
    rules_accessKey: "กรุณากรอก accessKey",
    rules_fixPhone: "กรุณากรอกเบอร์โทรศัพให้ครบ 10 หลัก",
    formatEmail: "รูปแบบ email ไม่ถูกต้อง"
  },
  systemMaintenance: {
    title: "ประกาศแจ้งให้ทราบ"
  },
  dialogMailrelayCount: {
    no: "ลำดับ",
    date: "วันที่เปิดอ่าน",
    tiem: "เวลาที่เปิดอ่าน",
    detail: "รายละเอียดการเปิดอ่านอีเมล",
    close: "ปิด"
  },
  running_number: {
    title: "สร้างรูปแบบเลขที่เอกสาร",
    title_add: "สร้างรูปแบบเลขที่เอกสาร",
    title_edit: "แก้ไขรูปแบบเลขที่เอกสาร",
    note:
      "หมายเหตุ: กำหนดจำนวน Digit หมายเลขเพื่อใช้ในการสร้างหมายเลข เช่น 00001",
    btn_create_form: "สร้างรูปแบบเลขที่เอกสาร",
    condition: {
      title: "ค้นหา",
      btn_edit: "แก้ไขข้อมูล",
      btn_delete: "ลบข้อมูล",
      btn_cancle: "ยกเลิก",
      btn_save: "บันทึก",
      condition_doctype: "ประเภทเอกสาร",
      condition_ruleDoctype: "กรุณากรอกเลือกประเภทเอกสาร",
      condition_ruleText: "กรุณากรอก ข้อความ/สัญลักษณ์",
      condition_ruleRunningNum: "กรุณากรอก Running Number",
      condition_numType: "รูปแบบเลขที่",
      condition_example: "ตัวอย่าง",
      condition_text: "ข้อความ/สัญลักษณ์",
      condition_date: "วันที่",
      condition_month: "เดือน",
      condition_year: "ปี",
      condition_type: "รูปแบบ",
      condition_message: "ข้อความ"
    },
    table: {
      header_no: "ลำดับ",
      header_doc_type: "ประเภทเอกสาร",
      header_form_id: "เลขที่ฟอร์ม",
      header_creater_name: "ชื่อผู้สร้าง",
      header_create_dtm: "วันที่สร้าง",
      header_using: "การใช้งาน",
      header_action: "ตัวเลือก"
    },
    dowloadind_data: "กำลังดาวน์โหลดข้อมูล...",
    swal: {
      save_success: "บันทึกข้อมูลสำเร็จ",
      server_err: "ไม่สามารถบันทึกข้อมูลได้",
      select_documents: "กรุณาเลือกประเภทเอกสาร",
      select_runningNumber: "กรุณาเลือก Running Number",
      notify_creat_form: "สร้างรูปแบบฟอร์มเรียบร้อย",
      delete_success: "ลบข้อมูลสำเร็จ",
      notify_select_running_number: "กรุณาเลือกรูปแบบ Running Number"
    }
  },
  openApi: {
    invoice: "ใบกำกับภาษี",
    receipt: "ใบเสร็จรับเงิน",
    cash: "ใบเสร็จรับเงิน / ใบกำกับภาษี (เงินสด)",
    login: "กำลังเข้าสู่ระบบ Open API ...",
    listItem: [
      { text: "ใบกำกับภาษี", value: "tax-invoices" },
      { text: "ใบเสร็จรับเงิน", value: "receipts" },
      { text: "ใบเสร็จรับเงิน / ใบกำกับภาษี (เงินสด)", value: "cash-invoices" },
      { text: "ใบแจ้งหนี้", value: "billing-notes" },
    ],
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      button_create_etax: "สร้าง E-tax",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      condition_listdoc: "รายการเอกสาร",
      condition_listdocItem: [
        { value: "", text: "ทั้งหมด" },
        { value: "0", text: "เอกสารปกติ" },
        { value: "1", text: "เอกสารยกเลิก/ออกแทน" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_buyer_taxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      condition_buyer_name: "ชื่อผู้เสียภาษีอากร(ผู้ซื้อ)",
      condition_buyer_branchid: "เลขที่สาขา(ผู้ซื้อ)",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_processhint_to: "กรุณาเลือกเอกสารลงวันที่ (ถึง)",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      condition_fromemail: "วันที่ส่งอีเมล",
      condition_toemail: "ถึง",
      condition_status_email: "สถานะอีเมล",
      waiting_for_delivery: "รอนำส่ง"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "เอกสาร ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      doc_id: "เลขที่เอกสาร",
      dueDate: "วันที่ครบกำหนด",
      Document_date: "เอกสารลงวันที่",
      buyer_tax: "เลขประจำตัวผู้ซื้อ",
      buyer_name: "ชื่อผู้ซื้อ",
      buyer_branch: "เลขที่สาขาผู้ซื้อ",
      no_data: "ไม่มีข้อมูล"
    },
    swal: {
      server_err: "ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อผู้ดูแลระบบ",
      specify: "กรุณาระบุเงื่อนไข",
      title: "เอกสารลงวันที่ และ เอกสารลงวันที่ (ถึง) "
    },
    dialog: {
      title: "ยืนยันการสร้าง E-tax",
      subTitle: "ตัวเลือกสำหรับส่งไฟล์ e-tax",
      sub_Title: "ยังไม่ได้เลือกออฟชั่นส่งไฟล์",
      messageSuccess: "สร้าง E-tax สำเร็จ",
      messageSuccess1: "สามารถตรวจสอบเอกสารได้ที่ เมนูคัดค้นเอกสาร",
      table: {
        title: "รายการสร้าง E-tax",
        no: "ลำดับ",
        doc_id: "เลขที่เอกสาร",
        buyer_tax: "เลขประจำตัวผู้ซื้อ",
        buyer_name: "ชื่อผู้ซื้อ",
        status: "สถานะ",
        note: "หมายเหตุ",
        email: "อีเมล",
        action: "ตัวเลือก",
        status_process: "กำลังสร้าง",
        note_1:
          "หมายเหตุ: สามารถตรวจสอบเอกสารที่สร้าง E-Tax สำเร็จ ได้ที่เมนูคัดค้นเอกสาร",
        process: "กำลังสร้าง",
        error: "สร้างไม่สำเร็จ",
        success: "สร้างสำเร็จ",
        close: "ปิด"
      },
      btn_cancle: "ยกเลิก",
      btn_save: "บันทึก",
      title_list: "เปิดใช้งานระบบ OPEN API",
      sub_title_list:
        "กรุณากรอก Usercode AccessKey เพื่อเปิดใช้งานระบบ OPEN API",
      note:
        "** สามารถดูข้อมูล Usercode, AccessKey ได้ที่ เอกสารการเชื่อมต่อ e-Tax service"
    }
  },
  cancleEtax: {
    title: "สร้างใบลดหนี้",
    tab_one: "ออกใบลดหนี้(เต็มจำนวน)",
    tab_two: "ออกใบลดหนี้(บางส่วน)",
    tab_three: "ออกใบลดหนี้เต็มจำนวน(ABB)",
    title_list: "เปิดใช้งานระบบ สร้างใบลดหนี้",
    sub_title_list:
      "กรุณากรอก Usercode AccessKey เพื่อเปิดใช้งานระบบ สร้างใบลดหนี้",
    button_create_creditnote: "สร้างใบลดหนี้",
    btn_download: "ดาวน์โหลด pdf",
    doctype_list_all: [
      { value: "", text: "ทั้งหมด" },
      { value: "388", text: "ใบกำกับภาษี" },
      { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
      { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
      { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
      { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
    ],
    table: {
      title: "รายการสร้าง E-tax",
      no: "ลำดับ",
      doc_id: "เลขที่เอกสาร",
      buyer_tax: "เลขประจำตัวผู้ซื้อ",
      buyer_name: "ชื่อผู้ซื้อ",
      status: "สถานะ",
      note: "หมายเหตุ",
      status_process: "กำลังสร้าง",
      note_1:
        "หมายเหตุ: สามารถตรวจสอบเอกสารที่สร้าง E-Tax สำเร็จ ได้ที่เมนูคัดค้นเอกสาร",
      process: "กำลังสร้าง",
      error: "สร้างไม่สำเร็จ",
      success: "สร้างสำเร็จ",
      close: "ปิด",
      fileName: "ชื่อไฟล์",
      new_doc_no: "เลขที่เอกสาร(ใบลดหนี้)"
    },
    swal: {
      specify: "กรุณาระบุเงื่อนไข",
      title: "เอกสารลงวันที่ หรือ วันที่ส่งเอกสาร อย่างใดอย่างหนึ่ง ",
      subTitle: "กรุณาเลือกข้อมูลสำหรับสร้าง E-tax",
      textCNAgain:
        "เอกสารดังกล่าวเคยออกเอกสารลดหนี้เต็มจำนวนแล้ว\nต้องการทำรายการต่อหรือไม่?",
    },
    condition: {
      condition_original_document_value: "มูลค่าตามเอกสารเดิม",
      condition_correct_value: "มูลค่าที่ถูกต้อง",
      condition_difference: "ผลต่าง",
      condition_total_money: "รวมเป็นเงิน", // รวมมูลค่า
      condition_discount_included: "ส่วนลด", // มูลค่าส่วนลด
      condition_amount_after_discount: "จำนวนเงินหลังหักส่วนลด",
      condition_vat: "ภาษีมูลค่าเพิ่ม", // มูลค่าภาษี
      condition_discount_excluded: "ราคาไม่รวมภาษีมูลค่าเพิ่ม",
      condition_total_sum: "จำนวนเงินรวมทั้งสิ้น" // จำนวนเงินสุทธิ
    },
    buttom: {
      cancel: "ยกเลิก",
      continue: "ดำเนินการต่อ",
    },
  },
  group_user: {
    title: "กำหนดการเข้าถึงข้อมูล (สาขาผู้ขาย)",
    btn_create: "สร้างกลุ่มการเข้าถึงข้อมูล",
    note_delete: "คุณต้องการลบ ",
    alert_create: "สร้าง Group สำเร็จ",
    alert_catch: "ไม่สามารถใช้งานการตั้งค่า Group ได้ในขณะนี้",
    alert_delete: "ลบข้อมูล Group สำเร็จ",
    alert_update: "แก้ไขข้อมูลสำเร็จ",
    alert_selectBranch: "กรุณาเลือก Branch",
    alert_enableGroup: "เปิดใช้งานการกำหนดการเข้าถึงข้อมูล (สาขาผู้ขาย) สำเร็จ",
    alert_disableGroup: "ปิดใช้งานการกำหนดการเข้าถึงข้อมูล (สาขาผู้ขาย) สำเร็จ",
    title_enableGroup: "เปิดใช้งานการกำหนดการเข้าถึงข้อมูล (สาขาผู้ขาย) ",
    title_disableGroup: "ปิดใช้งานการกำหนดการเข้าถึงข้อมูล (สาขาผู้ขาย) ",
    dialog_load: "กำลังโหลดข้อมูล...",
    view_more: "ดูเพิ่มเติม",
    tips_edit: "แก้ไขข้อมูล",
    tips_delete: "ลบข้อมูล",
    label_group_name: "ชื่อกลุ่มการเข้าถึง",
    label_status: "สถานะการใช้งาน",
    label_group_branch: "เข้าถึงข้อมูลสาขา",
    label_group_user: "ผู้ใช้งานที่มีสิทธิ์เข้าถึงข้อมูล",
    table_group_name: "ชื่อกลุ่มการเข้าถึง",
    table_status: "สถานะการใช้งาน",
    table_group_branch: "เข้าถึงข้อมูลสาขา",
    table_group_user: "ผู้ใช้งานที่มีสิทธิ์เข้าถึงข้อมูล",
    table_action: "จัดการ",
    label_group_name_select: "ชื่อกลุ่มสาขา(ผู้ขาย)"
  },
  landingpage_index: {
    title: "ใบกำกับภาษีอิเล็กทรอนิกส์",
    subTitle: "โซลูชันใหม่ที่ช่วยลดต้นทุนให้ธุรกิจทุกขนาด",
    detailSystemEtax:
      "ระบบ etax.one.th ได้รับการรับรองตามข้อเสนอแนะมาตรฐาน จากสำนักงานพัฒนาธุรกรรมทางอิเล็กทรอนิกส์ (สพธอ.) ETDA ว่าด้วยการรักษาความมั่นคงความปลอดภัยสารสนเทศสำหรับผู้ให้บริการจัดทำส่งมอบ และเก็บรักษาข้อมูลอิเล็กทรอนิกส์ (ขมธอ. 21-2562)",
    basicLevel: "ระดับพื้นฐาน",
    switchEtax: "เปลี่ยนมาใช้ใบกำกับภาษีอิเล็กทรอนิกส์ (e-Tax Invoice) วันนี้",
    issuingTax: "ออกใบกำกับภาษี",
    issuingReceipt: "ออกใบเสร็จรับเงิน",
    issueCredit: "ออกใบลดหนี้ ใบเพิ่มหนี้",
    sendInfo: "ส่งข้อมูลถึงกรมสรรพากรโดยตรง",
    generateTax: "ทำรายงานภาษีซื้อ-ขายอัตโนมัติ",
    saveTime: "ประหยัดเวลาในการส่ง",
    reduceCost: "ลดต้นทุนในการทำธุรกิจ",
    safeReliable: " ปลอดภัยและเชื่อถือได้ 100%",
    detailEtax:
      "ระบบบริการจัดทำและนำส่งข้อมูลใบกำกับภาษีอิเล็กทรอนิกส์และใบรับอิเล็กทรอนิกส์ โดยผู้ประกอบการต้องจัดทำใบกำกับภาษี ใบเพิ่มหนี้ ใบลดหนี้และใบรับให้อยู่ในรูปของข้อมูลอิเล็กทรอนิกส์มีการลงลายมือชื่อดิจิทัล(Digital Signature) ที่มีความปลอดภัยและเป็นมาตรฐานสากล และนำส่งข้อมูลให้กรมสรรพากร ใบกำกับภาษีอิเล็กทรอนิกส์ที่ออกผ่านระบบ e-Tax Invoice & e-Receipt จะเป็นมาตรฐานที่มีผลทางกฏหมายโดยจะต้องระบุหมายเลขใบรับรองอิเล็กทรอนิกส์ และลายมือชื่อดิจิตอลเป็นเครื่องยืนยันตัวตนของผู้ออกใบกำกับภาษี(ผู้ขาย) และรับรองถึงความถูกต้องของข้อมูล",
    detailEmail:
      "เหมาะสำหรับผู้ประกอบการจดทะเบียนภาษีมูลค่าเพิ่มรายย่อยที่มีรายได้ไม่เกิน 30 ล้านบาทต่อปีที มีการออกใบกํากับภาษีจํานวนไม่มาก ไม่มีการบริหารจัดการด้านเอกสารที่เป็นระบบขนาดใหญ่ และอาจจะยังไม่พร้อมจะออกใบกํากับภาษีอิเล็กทรอนิกส์ได้อย่างสมบูรณ์ตามที่กรมสรรพากรกําหนดผ่านระบบกลางของสพธอ. ขั้นตอนไม่ยุ่งยาก โดยผู้ประกอบการจดทะเบียนจัดทำส่งมอบและเก็บรักษาใบกำกับภาษีอิเล็กทรอนิกส์ผ่านทางอีเมล โดยการประทับรับรองเวลา (Time Stamp) และระบบจะส่งไฟล์ข้อมูลนั้นให้กับผู้ซื้อและผู้ขายสินค้าเพื่อจัดเก็บหรือใช้เป็นหลักฐานในการทำธุรกรรม"
  },
  createCancleInstead: {
    title: "สร้างใบลดหนี้",
    condition: {
      title: "ระบุเงื่อนไขการค้นหา",
      button_search: "ค้นหา",
      button_cler: "เคลียร์ข้อมูล",
      button_excel: "ขอไฟล์ EXCEL",
      button_download: "ดาวน์โหลดเอกสาร",
      button_download_all: "ดาวน์โหลดเอกสารทั้งหมด",
      button_download_aselect: "ดาวน์โหลดเอกสารที่เลือก",
      detail_doc_date: "เอกสารลงวันที่ คือวันที่ระบุลงในเอกสาร",
      detail_from_date: "วันที่ส่งเอกสาร คือวันที่นำเอกสารเข้าสู่ระบบ etax",
      condition_docid: "เลขที่เอกสาร",
      condition_todocid: "ถึง",
      condition_doctype: "ประเภทเอกสาร",
      condition_date_pressing: "วันที่กดส่งเมลซ้ำอีกครั้ง",
      button_xml: "สร้างใบลดหนี้ด้วย XML ไฟล์",
      notFound_runnumber: "ไม่พบข้อมูลการตั้งค่าเลขที่เอกสารอัตโนมัติ",
      document_manual: "เลขที่เอกสาร",
      runnumber: "เลขที่เอกสารอัตโนมัติ",
      runmanual: "กรอกเลขที่ด้วยตัวเอง",
      fill_documentID: "กรุณากรอกเลขที่เอกสาร",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "T07", text: "ใบแจ้งยกเลิกเอกสาร" },
        { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
        { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "383", text: "ใบเพิ่มหนี้การค้า" },
        { value: "381", text: "ใบลดหนี้การค้า" },
        { value: "207", text: "ใบส่งของ" },
        { value: "325", text: "บัญชีสินค้าเดินพิธี" },
        { value: "623", text: "ใบเสร็จค่า Freight" }
      ],
      numberType: [
        { value: "invoice_number", text: "หมายเลข Invoice" },
        { value: "running_number", text: "Running number" }
      ],
      condition_seller_branchid: "เลขที่สาขา(ผู้ขาย)",
      condition_numberType: "ประเภทหมายเลขเอกสาร",
      condition_fromdate: "วันที่ส่งเอกสาร",
      condition_todate: "ถึง",
      condition_processhint: "กรุณาเลือกเอกสารลงวันที่",
      condition_fromdatedoc: "เอกสารลงวันที่",
      condition_todatedoc: "ถึง",
      condition_close_dialog: "ปิด",
      condition_locale: "TH",
      rulesReason: "ระบุเหตุผลในการสร้างใบลดหนี้"
    },
    detail: {
      doc_found: "จำนวนเอกสารที่ค้นพบ :",
      pdf: "ไฟล์ PDF ที่เลือก :",
      xml: "ไฟล์ XML ที่เลือก :"
    },
    table: {
      no: "ลำดับ",
      doc_id: "เลขที่เอกสาร",
      document_type: "ประเภทเอกสาร",
      process_date: "วันที่ส่งเอกสาร",
      document_date: "เอกสารลงวันที่",
      reportinstead_id: "เลขที่เอกสารเดิม",
      reportinstead_date: "วันที่เอกสารเดิม",
      taxid: "เลขประจำตัวผู้เสียภาษีผู้ซื้อ ",
      buyer_name: "ชื่อผู้ซื้อ",
      buyer_branch: "เลขที่สาขาผู้ซื้อ",
      action: "ตัวเลือก",
      no_data: "ไม่มีข้อมูล"
    },
    dialog_email: {
      noemail_text1: "ไม่พบอีเมลสำหรับส่งไฟล์",
      noemail_text2: "ระบุอีเมลที่ต้องการส่งไฟล์",
      noemail_text3: "ต้องการเพิ่มอีเมลหรือไม่?",
      noemail_input: "อีเมลแอดเดรส",
      havemail_text1: "คุณต้องการส่งไฟล์ไปยัง",
      havemail_text2: "อีกครั้งหรือไม่?",
      havemail_text3: "Email ที่ส่งคราวที่เเล้ว",
      havemail_text4: "Email ใน Database",
      havemail_text5: "Email ใหม่",
      havemail_input: "อีเมลแอดเดรส",
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      loading: "กำลังส่ง...",
      complete: "สำเร็จ",
      btn_confirm: "ยืนยันการส่ง",
      btn_edit: "แก้ไขอีเมล",
      btn_add: "เพิ่มอีเมล"
    },
    dialog_download: {
      accesskey_text1: "กรุณากรอก accesskey",
      accesskey_text2: "หมายเหตุ: accesskey จะใช้ได้เป็นระยะเวลา 15 นาที",
      notify_text1: "การดาวน์โหลดไฟล์ใช้เวลานาน ",
      notify_text2: "ต้องการดาวน์โหลดหรือไม่?",
      btn_confirm: "ยืนยัน",
      loading_download: "กำลังดาวน์โหลด.."
    },
    swal: {
      server_err: "ไม่สามารถเชื่อมต่อเซิฟเวอร์ได้",
      accesskey_err: "AccessKey ไม่ถูกต้อง",
      download_err: "ไม่สามารถโหลดไฟล์ได้",
      morefile_err: "เอกสารเลขที่ดังกล่าวมีจำนวนไฟล์มากกว่า 1 ไฟล์",
      data_download_err: "การดาวน์โหลดไฟล์ใช้เวลานาน",
      notify_download_excel: "ต้องการดาวน์โหลดข้อมูลหรือไม่ ?",
      notify_email_err: "ไม่พบเอกสารในระบบ ที่ใช้สำหรับส่งอีเมลซ้ำ",
      title_token: "Token ONE หมดอายุ",
      subtitle_token: "กรุณาเข้าสู่ระบบใหม่เพื่อรีเฟรช token",
      btn_cancle: "ยกเลิก",
      btn_logout: "ออกจากระบบ",
      selectXml: "เลือกไฟล์ XML",
      selectXml_label: "กรุณาเลือกไฟล์ XML",
      titlePropose: "เหตุผลการยกเลิกเอกสาร",
      title_Propose: "เหตุผลการลดหนี้",
      titleProposeInput: "ระบุเหตุผล",
    },
    itemProposeCode: [
      { text: "ลดราคาสินค้าที่ขาย (สินค้าผิดข้อกำหนดที่ตกลงกัน)", value: "CDNG01"},
      { text: "สินค้าชำรุดเสียหาย", value: "CDNG02" },
      { text: "สินค้าขาดจำนวนตามที่ตกลงซื้อขาย", value: "CDNG03" },
      { text: "คำนวณราคาสินค้าผิดพลาดสูงกว่าที่เป็นจริง", value: "CDNG04"},
      { text: "รับคืนสินค้า (ไม่ตรงตามคำพรรณนา)", value: "CDNG05" },
      //{ text: "เหตุอื่น (ระบุสาเหตุ)", value: "CDNG99" },
      { text: "ลดราคาค่าบริการ (บริการผิดข้อกำหนดที่ตกลงกัน)", value: "CDNS01"},
      { text: "ค่าบริการขาดจำนวน", value: "CDNS02" },
      { text: "คำนวณราคาค่าบริการผิดพลาดสูงกว่าที่เป็นจริง", value: "CDNS03"},
      { text: "บอกเลิกสัญญาบริการ", value: "CDNS04" },
      { text: "เหตุอื่น (ระบุสาเหตุ)", value: "CDNS99" },
    ],
  },
  editTaxinvoice: {
    btnCreateXml: "ออกแทนเอกสารด้วย xml ไฟล์",
    detailEdit: "รายละเอียดข้อมูลการออกแทน",
    buyerInfo: "ข้อมูลสำหรับการออกแทน",
    btnEdit: "แก้ไข",
    dataNotFound: "ไม่พบข้อมูล",
    detail: "ดูรายละเอียด",
    close: "ปิด",
    dialogConfirm: {
      title: "เปิดใช้งานระบบ ",
      subTitle: "กรุณากรอก Usercode และ AccessKey เพื่อเปิดใช้งาน",
      detailSubTitle: "ระบบ"
    },
    dialogEditTaxinvoice: {
      pleaseEnter: "กรอกเอง",
      typeResend: "รูปแแบบการส่ง Resend",
      buyerId: "รหัสผู้ซื้อ",
      buyerName: "ชื่อผู้ซื้อ",
      consigneeCode: "รหัสผู้รับสินค้า",
      consigneeName: "ชื่อผู้รับสินค้า",
      issueAssignedId: "เลขอ้างอิง Order",
      issueAssignedIdOth: "เลขที่ใบสั่งซื้อ",
      buyerEmail: "อีเมลผู้ซื้อ",
      lineOne: "ที่อยู่ผู้ซื้อบรรทัดที่ 1",
      lineTwo: "ที่อยู่ผู้ซื้อบรรทัดที่ 2",
      lineThree: "ที่อยู่ผู้ซื้อบรรทัดที่ 3",
      postcode: "รหัสไปรษณีย์",
      countryId: "รหัสประเทศ",
      phoneBranch: "เบอร์โทรสาขาที่ออกใบกำกับภาษี",
      totalPieces: "แผนกผู้ขาย",
      dataDocument: "ข้อมูลเอกสาร",
      documentId: "เลขที่เอกสาร",
      documentType: "ประเภทเอกสาร",
      ruleDocumentId: "กรุณากรอกเลขที่เอกสาร",
      documentDate: "เอกสารลงวันที่",
      ruleDoumentDate: "กรุณาเลือกเอกสารลงวันที่",
      ruleCountryID: "กรุณาระบุรหัสประเทศ",
      rulePostCode: "กรุณาระบุรหัสไปรษณีย์",
      purpose: "รหัสเหตุผลในการออกใบใหม่ทดแทนใบเดิม",
      rulePurpose: "กรุณากรอกรหัสเหตุผลในการออกใบใหม่ทดแทนใบเดิม",
      documentName: "ชื่อเอกสาร",
      ruleDocumentName: "ชื่อเอกสาร",
      taxid: "เลขประจำตัวผู้เสียภาษี",
      ruleTaxid: "กรุณากรอกเลขประจำตัวผู้เสียภาษี",
      additionalRefIssuerAssignedID: "เลขที่เอกสารอ้างอิง",
      additionalRefIssueDateTime: "วันที่เอกสารอ้างอิง",
      ruleAdditionalRefIssueDateTime: "กรุณาเลือกวันที่เอกสารอ้างอิง",
      branchId: "เลขที่สาขา",
      ruleBranchId: "กรุณากรอกเลขที่สาขา",
      documentRemark2: "อ้างอิง e-Credit Voucher",
      flexfield: "เหตุผลในการออกใบใหม่ทดแทนใบเดิม",
      documentRemark: "ข่าวสำคัญโปรดอ่าน",
      documentRemark1: "ยอดคำสั่งซื้อ PV",
      documentRemarkBV: "ยอดคำสั่งซื้อ BV",
      documentRemark3: "ยอดส่วนตัว|ยอดกลุ่ม PV หรือ คะแนนแอมพลัส PV",
      documentRemark4: "ยอดส่วนตัว|ยอดกลุ่ม BV หรือ คะแนนแอมพลัส BV",
      documentRemark5: "รายละเอียดท้ายตารางสินค้า 1",
      documentRemark8: "รายละเอียดท้ายตารางสินค้า 2",
      documentRemark9: "รายละเอียดท้ายตารางสินค้า 3",
      documentRemark10: "รายละเอียดท้ายตารางสินค้า 4",
      payee: "ผู้รับเงิน - วันที่รับเงิน",
      newIssue: "กรณีออกใหม่ทดแทนใบเดิม",
      newPurpose: "Purpose ในการออกใหม่ทดแทนใบเดิม",
      btnNext: "ถัดไป",
      btnCancle: "ยกเลิก",
      btnBack: "ย้อนกลับ",
      btnPreview: "ดูเอกสารตัวอย่าง",
      selectServiceCode: "เลือก Servicecode",
      selectPDF: "เลือกไฟล์ PDF",
      supportPDFOnly: "รองรับไฟล์ PDF เท่านั้น",
      newPurposetoOld: "เหตุผลในการออกใบใหม่ทดแทนใบเดิม",
      newPurposeCodetoOld: "รหัสเหตุผลในการออกใบใหม่ทดแทนใบเดิม",
      additionalRefIssueTypecode: "ประเภทเอกสารอ้างอิง",
      buyerTaxid: "เลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      ruleBuyerTaxid: "กรุณากรอกเลขประจำตัวผู้เสียภาษี(ผู้ซื้อ)",
      buyerBranchId: "เลขที่สาขาผู้ซื้อ",
      ruleBuyerBranchId: "กรุณากรอกเลขที่สาขาผู้ซื้อ",
      buyerOrderReferencedDocument: "เลขที่อ้างอิงใบสั่งซื้อ",
      orderIssueDateTime: "วันที่อ้างอิงใบสั่งซื้อ",
      ruleBuyerName: "กรุณากรอกชื่อผู้ซื้อ",
      ruleDocumentNumber: "กรุณากรอกเลขที่เอกสารอ้างอิง",
      rulePropose: "กรุณาเลือกรหัสเหตุผลการออกแทน",
      rulePropose99: "กรุณาระบุเหตุผลในการออกใบใหม่ทดแทนใบเดิม",

      business_type: "ประเภทธุรกิจ",
      title_buyer_info: "ข้อมูลผู้ซื้อ",
      guest: "บุคคลทั่วไป",
      juristic_person: "นิติบุคคล",
      passport: "หนังสือเดินทาง",
      other: "อื่นๆ",
      totalOfPieces: "ยอดรวมจำนวนชิ้น",
      pdftitle: "ตัวเลือกอัพโหลดไฟล์ PDF",
      pdfSubTitle:
        "อัพโหลดไฟล์ PDF หากต้องการสร้างเอกสารด้วยไฟล์ PDF ที่มีอยู่",
      dropFole: "ลากไฟล์และวางที่นี่หรือคลิกเพื่ออัปโหลดไฟล์",
      upload: "อัปโหลด",
      view: "ดูรายละเอียด",
      close: "ปิด"
    },
    swal: {
      warning: "คำเตือน",
      requird: "กรุณาระบุข้อมูลให้ครบ",
      autorunFail: "เลข Autorun ไม่สามารถใช้งานได้",
      formatEmail: "รูปแบบอีเมลไม่ถูกต้อง",
      uploadPdfOne: "อัปโหลดไฟล์ได้ครั้งละไม่เกิน 1 ไฟล์",
      fileAccept: "รองรับเฉพาะไฟล์ PDF เท่านั้น",
      fileXmlAccept: "รองรับเฉพาะไฟล์ XML เท่านั้น",
      sendmail: "กรุณากรอกข้อมูลอีเมลผู้ซื้อ เพื่อใช้งานการส่งอีเมล"
    }
  },
  revenue_status: {
    swalSearchTitle: "กรุณาระบุเงื่อนไข",
    swalSearchSubtitle:
      "เอกสารลงวันที่, วันที่ส่งเอกสาร, วันที่กดนำส่งสรรพากร อย่างใดอย่างหนึ่ง"
  },
  sftpList: {
    title: "ระบบรับรองเอกสาร",
    condition: {
      statusDoc: "สถานะเอกสาร",
      dataType: "ประเภทข้อมูล",
      seller_branch: "สาขาผู้ขาย",
      documentName: "ชื่อไฟล์เอกสาร",
      file_create: "วันที่สร้างไฟล์",
      file_to: "ถึงวันที่",
      file_found: "จำนวนไฟล์ที่ค้นพบ :",
      name: "ชื่อ-นามสกุล",
      tel: "เบอร์โทร",
      email: "อีเมล",
      position: "ตำแหน่ง",
      infor: "ข้อมูลบัญชีผู้ใช้",
      buyer_taxid: "เลขประจำตัวผู้ซื้อ",
      contract_number: "เลขที่สัญญา",
      file: "ไฟล์",
      delete_title: "ยืนยันการยกเลิก ?",
      delete_sub_title: "คุณต้องการยกเลิก ",
      reject_title: "ยืนยันการยกเลิกเอกสาร",
      reject_or: "ใช่หรือไม่",
      reject_sub_titile: "ยกเลิกเอกสาร ",
      reject_success: " สำเร็จ",
      btnCancel: "ยกเลิก",
      fromdatedoc: "เอกสารลงวันที่",
      select_reject: "เลือกรายการที่ต้องการปฏิเสธ",
      num_doc: "จำนวนเอกสารที่ปฏิเสธ",
      list: "รายการ",
      btn_confirm: "ยืนยัน",
      btnBack: "ย้อนกลับ",
      confirm_tran: "ยืนยันการทำรายการ",
      fromdate: "วันที่ส่งเอกสาร",
      trans_date: "วันที่ทำรายการ",
      trans_per: "ผู้ทำรายการ",
      doctype_list: [
        { value: "", text: "ทุกประเภท" },
        { value: "380", text: "ใบแจ้งหนี้" },
        { value: "388", text: "ใบกำกับภาษี" },
        { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
        { value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" },
        { value: "80", text: "ใบเพิ่มหนี้" },
        { value: "81", text: "ใบลดหนี้" }
      ],
      item_batchType: [
        { value: "eTax", text: "eTax" },
        { value: "eBill", text: "eBill" }
      ]
    },
    table: {
      file_name: "ชื่อไฟล์เอกสาร",
      file_create: "วันที่สร้างไฟล์",
      file_status: "สถานะเอกสาร",
      doc_All: "จำนวนเอกสารทั้งหมด",
      doc_confrim: "จำนวนเอกสารที่อนุมัติ",
      doc_cancle: "จำนวนเอกสารที่ปฏิเสธ",
      approver: "ผู้อนุมัติ",
      date_approver: "วันที่ดำเนินการ",
      doc_list: "ดูรายละเอียดไฟล์",
      doc_reject: "ยกเลิกไฟล์",
      status: "สถานะ",
      customer_name: "ชื่อลูกค้า",
      details: "รายละเอียด"
    },
    status: {
      count_approve: "ดำเนินการเรียบร้อย",
      count_pending: "รอดำเนินการ",
      count_docAll: "รายการทั้งหมด",
      approve: "ตรวจสอบแล้ว",
      reject: "ยกเลิก",
      registering: "กำลังนำเข้าเอกสาร",
      pending: "รอตรวจสอบ",
      fail: "Batch ไฟล์ไม่ผ่านการตรวจสอบ",
      count_doc_pending: "รายการรออนุมัติ",
      count_doc_reject: "รายการยกเลิก",
      count_doc_approve: "รายการอนุมัติ",
      chip_success: "สร้างเอกสารสำเร็จ",
      chip_fail: "สร้างเอกสารไม่สำเร็จ",
      chip_pc: "เอกสารอยู่ในขั้นตอนการประมวลผล",
      pending_detail: "รออนุมัติ",
      approve_detail: "อนุมัติ",
      pc: "เอกสารอยู่ในขั้นตอนการประมวลผล",
    },
    swal: {
      specify: "กรุณาระบุเงื่อนไขให้ครบตามที่กำหนด",
      cancleSuccess: "ยกเลิกไฟล์สำเร็จ",
      confirm_success:
        "ระบบกำลังประมวลผล ท่านสามารถเข้ามาตรวจสอบสถานะเอกสารได้ในภายหลัง",
      success: "สำเร็จ",
      process: "ระบบกำลังสร้างเอกสาร สามารถเข้ามาตรวจสอบสถานะได้ในภายหลัง"
    },
    require: {
      date: "กรุณาระบุ วันที่สร้างไฟล์",
      todate: "กรุณาระบุ ถึงวันที่",
      type: "กรุณาระบุ ประเภทข้อมูล",
      docStatus: "กรุณาระบุ สถานะเอกสาร"
    }
  },
  login: {
    credentials_fail: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง !! กรุณาลองใหม่",
    business_not: "ไม่พบบัญชีนิติบุคคล หรือบัญชีนิติบุคคลอยู่ในระหว่างตรวจสอบ",
    denied_request: "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง",
    success: "เข้าสู่ระบบสำเร็จ"
  },
  approveDocument: {
    title: 'อนุมัติเอกสาร',
    buyer_address: {
      title_taxpayer_info: 'ข้อมูลผู้เสียภาษีอากร',
      nameCompany: 'ชื่อ/บริษัท (ผู้เสียภาษีอากร)',
      lableTaxid: 'เลขประจำตัวผู้เสียภาษีอากร',
      address: 'ที่อยู่',
      buyer_branch: 'เลขที่สาขา',
      email: 'อีเมล',
      phone: 'โทรศัพท์',
    },
    seller_detail: {
      seller_info: 'ข้อมูลผู้ขาย',
      seller_branch_id: 'สาขาผู้ขาย',
      document_type: 'ประเภทเอกสาร',
      document_id: 'เลขที่เอกสาร',
      document_id_ref: 'เลขที่เอกสาร (อ้างอิง)',
      document_date: 'เอกสารลงวันที่',
      document_date_ref: 'เอกสารลงวันที่ (อ้างอิง)',
      total_amount: 'จำนวนเงินทั้งหมด',
      docTypeList: [
        {text: "ใบแจ้งหนี้", value: "380"},
        {text: "ใบกำกับภาษี", value: "388"},
        {text: "ใบรับ (ใบเสร็จรับเงิน)", value: "T01"},
        {text: "ใบแจ้หนี้/ใบกำกับภาษี", value: "T02"},
        {text: "ใบเสร็จรับเงิน/ใบกำกับภาษี", value: "T03"},
        {text: "ใบส่งของ/ใบกำกับภาษี", value: "T04"},
      ]
    },
    actions: {
      btnBack: 'ย้อนกลับ',
      btnReject: 'ปฏิเสธคำขอ',
      btnPreview: 'ดูตัวอย่าง',
      btnCreate: 'สร้าง',
      searchAgain: "ค้นหาข้อมูลอีกครั้ง"
    },
    dialog: {
      title_dialog: "ยืนยันการสร้างเอกสาร",
      btnBack: 'ย้อนกลับ',
      btnConfirm: 'ยืนยัน',
      btnCreate: 'สร้าง',
      error: 'ผิดพลาด',
      errMsg: 'ไม่สามารถใช้งานระบบได้ในขณะนี้',
      document_reject: 'สาเหตุการปฏิเสธเอกสาร',
      reasonReject: {
        document_id_found: 'ไม่พบเลขที่เอกสารที่ระบุ',
        document_date_found: 'ไม่พบเอกสารตามวันที่ที่ระบุ',
        document_total_amount_found: 'ไม่พบเอกสารที่มีจำนวนเงินตามที่ระบุ',
        document_other: 'อื่นๆ',
      }

    },
    condition_listproduct: 'รายการสินค้า / บริการ',
    condition_additional_end_notes_more: 'หมายเหตุท้ายเอกสาร (เพิ่มเติม)',
    table: {
      no: 'ลำดับ',
      document_id: 'เลขที่เอกสาร',
      document_date: 'เอกสารลงวันที่',
      buyer_taxid: 'เลขประจำตัวผู้เสียภาษีอากร',
      process_dtm: 'วันที่สร้างเอกสาร',
      status: 'สถานะ',
      error_message: 'รายละเอียดสถานะเอกสาร',
    },
    process_status_success:  'เอกสารผ่านการตรวจสอบ',
    process_status_reject:  'เอกสารไม่ผ่านการตรวจสอบ',
    process_status_process: "กำลังดำเนิกการสร้าง e-tax",
    process_status_wait:  'เอกสารรอการตรวจสอบ',
    vatType: "ราคาสินค้า",
    vatTypeItems: [
      { text: "ราคารวมภาษี", value: "Include" },
      { text: "ราคาไม่รวมภาษี", value: "Exclude" },
    ]
  },
  document_ref_group: {
    tiv: [
      { value: "388", text: "ใบกำกับภาษี" },
      { value: "T02", text: "ใบแจ้งหนี้/ใบกำกับภาษี" },
      { value: "T03", text: "ใบเสร็จรับเงิน/ใบกำกับภาษี" },
      { value: "T04", text: "ใบส่งของ/ใบกำกับภาษี" },
    ],
    abb: [
      { value: "T05", text: "ใบกำกับภาษีอย่างย่อ" },
      { value: "T06", text: "ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ" },
    ],
    rct: [{ value: "T01", text: "ใบรับ (ใบเสร็จรับเงิน)" }],
    inv: [{ value: "380", text: "ใบแจ้งหนี้" }],
    cn: [{ value: "81", text: "ใบลดหนี้" }],
    dn: [{ value: "80", text: "ใบเพิ่มหนี้" }],
  },
};



// WEBPACK FOOTER //
// ./src/translations/locales/th.js